import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ICU from "i18next-icu";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            //A
            "All Orders": "All Orders",
            "An error occurred on the server while trying to log out. Reload the page and try again.":
                "An error has occurred on the server while trying to log out. Reload the page and try again.",
            "Another test": "Another test",
            Articles: "Articles",
            "Articles in trash can": "Deleted articles",
            "Add a category": "Add a category",
            "Adding a category": "Adding a category",
            Add: "Add",
            "Articles in the current category and subcategories": "Current category and subcategory articles",
            "Article in the trash can": "Deleted article",
            Author: "Author",
            "Available extensions": "Available extensions",
            "Adding of a physical address": "Adding of a physical address",
            "Adding a contact": "Adding a contact",
            "An error occurred while saving the partner.": "An error has occurred while saving the partner info.",
            "About the partner": "About the partner",
            "Additional information": "Additional information",
            "Additional services": "Additional services",
            Act: "Act",
            "Add a document": "Add a document",
            "Added contacts": "Added contacts",
            "Add a user": "Add a user",
            "Are you sure you want to delete the user?": "Are you sure you want to delete the user?",
            Address: "Address",
            "Added addresses": "Added addresses",
            "An error occurred while updating the partner.": "An error has occurred while updating the partner info.",
            "Add test participant": "Add test participant",
            "Add Photos": "Add Photos",
            "Autosomal markers": "Autosomal markers",
            "Are you sure you want to remove the member": "Are you sure you want to remove the member",
            "Additional participant": "Additional participant",
            "Abortive material": "Abortive material",
            "Application date": "Application date",
            "Application for change of personal data": "Application to change personal data",
            "Access is denied": "Access denied",
            "Attach a file": "Attach a file",
            Administrator: "Administrator",
            Accountant: "Accountant",
            "An error occured during the request.": "An error occured during the request.",
            "An error occurred during the request.": "An error occurred during the request.",
            "Add an address": "Add an address",
            "Add a contact": "Add a contact",
            "Account info": "Account info",
            Appeal: "Appeal",
            "Add a test": "Add a test",
            Alias: "Alias",
            "Are you sure": "Are you sure",
            "A file isn't chosen": "A file isn't chosen",
            "Attributes are loading": "Attributes are loading",
            "A partner is required": "A partner is required",
            "Agreed date of recording": "Agreed date of recording",
            "Agreed date": "Agreed date",
            "Appeal types are loading": "Appeal types are loading",
            "Add a phone": "Add a phone",
            Appeals: "Appeals",
            "Appeals are loading": "Appeals are loading",
            "Appeal ID": "Appeal ID",
            "After making a decision, refresh the page for the changes to take effect":
                "After making a decision, refresh the page for the changes to take effect",
            "Additional services are loading": "Additional services are loading",
            Agree: "Agree",
            "Add the slot": "Add the slot",
            "Added slots": "Added slots",
            "Article ID": "Article ID",
            "Articles studied by the partner's employees": "Articles studied by the partner's employees",
            "Add files": "Add files",
            "Add test participants": "Add test participants",
            "Average response time, in minutes": "Average response time, in minutes",
            "Average response time between messages": "Average response time between messages",
            "At least one participant has an empty name or nickname":
                "At least one participant has an empty name or nickname",
            "At least one participant has an empty degree of kinship":
                "At least one participant has an empty degree of kinship",
            "At least one participant has an empty sample type": "At least one participant has an empty sample type",
            "At least one participant has an empty photo": "At least one participant has an empty photo",
            "At least one participant has an empty identity document":
                "At least one participant has an empty identity document",
            "At least one participant does not have an uploaded ready profile":
                "At least one participant does not have an uploaded ready profile",
            Ascending: "Ascending",
            "Add range": "Add range",
            Active: "Active",
            "Are you sure you want to delete the requisite": "Are you sure you want to delete the requisite",
            "Are you sure you want to delete the OLF": "Are you sure you want to delete the OLF",
            "Are you sure you want to delete the OLF to requisite rule":
                "Are you sure you want to delete the OLF to requisite rule",
            "Alias must be less than 255 characters": "Alias must be less than 255 characters",
            "Alias must be unique": "Alias must be unique",
            "Are you sure you want to delete document type": "Are you sure you want to delete document type",
            "Are you sure you want to delete document status": "Are you sure you want to delete document status",
            "Are you sure you want to delete legal entity": "Are you sure you want to delete legal entity",
            "Are you sure you want to delete error": "Are you sure you want to delete error",
            "Are you sure you want to delete family step": "Are you sure you want to delete family step",
            "Attribute selection rules": "Attribute selection rules",
            "Are you sure you want to delete attribute selection rule":
                "Are you sure you want to delete attribute selection rule",
            "Attribute selection rules for N participants":
                "{N, plural,one {Attribute selection rule for {N} participant} other {Attribute selection rules for N participants}}",
            "Are you sure you want to delete attribute rule for N participants":
                "Are you sure you want to delete attribute rule for {depth, plural, =0 {N participants} =1 {{depth} participant} few {{depth} participants} many {{depth} participants} other {N participants}}",
            Answers: "Answers",
            Answer: "Answer",
            "At least one answer is required": "At least one answer is required",
            "Are you sure you want to delete survey item": "Are you sure you want to delete survey item",
            "Answer type rules": "Answer type rules",
            "Answer type rule": "Answer type rule",
            "Are you sure you want to delete answer type rule": "Are you sure you want to delete answer type rule",
            "Add a display condition": "Add a display condition",
            "Answer laboratory question for order": "Answer laboratory question for order",
            "Answer date": "Answer date",
            "Add rule": "Add rule",
            "Add at least 1 value": "Add at least 1 value",
            "At least one question is required": "At least one question is required",
            "Are you sure you want to delete file meaning": "Are you sure you want to delete file meaning",
            "Are you sure you want to delete file extension": "Are you sure you want to delete file extension",
            "Admin tools": "Admin tools",
            Access: "Access",
            "Are you sure you want to delete role": "Are you sure you want to delete role",
            "Are you sure you want to delete section": "Are you sure you want to delete section",
            "Are you sure you want to delete block": "Are you sure you want to delete block",
            Actions: "Actions",
            "Are you sure you want to delete menu section": "Are you sure you want to delete menu section",
            Action: "Action",
            "An error occurred while confirming the visit": "An error occurred while confirming the visit",
            "An error occurred while canceling the courier": "An error occurred while canceling the courier",
            "An error occurred while handing over to courier": "An error occurred while handing over to courier",
            "Add track number": "Add track number",
            "Are you sure you want to clear the list?": "Are you sure you want to clear the list?",
            "Appeal type": "Appeal type",
            "Automatic price calculation is under development":
                "Automatic price calculation is currently in test mode. Full and accurate pricing is expected by the end of February.",
            "Answer is given": "Answer is given",
            "Analysis order form": "Analysis order form",
            "Additional participants": "Additional participants",
            "Add a collection protocol file": "Add a collection protocol file",
            "Add a court ruling file": "Add a court ruling file",
            "Are you sure you want to delete hint": "Are you sure you want to delete hint",
            "Awaiting receipt of samples": "Awaiting receipt of samples",
            "A judicial test, recording is possible after receiving the ruling.":
                "A judicial test, recording is possible after receiving the ruling.",
            "Available buttons": "Available buttons",
            All: "All",
            "At least one participant has no informed consent uploaded":
                "At least one participant has no informed consent uploaded",
            "Additional service": "Additional service",
            "Are you sure you want to decline this additional service?":
                "Are you sure you want to decline this additional service?",
            "Additional service declined successfully.": "Additional service declined successfully.",
            "An error occurred while declining the additional service.":
                "An error occurred while declining the additional service.",
            "Additional service order created successfully.": "Additional service order created successfully.",
            "An error occurred while creating the additional service order.":
                "An error occurred while creating the additional service order.",
            "An error occurred while allowing the custom service order.":
                "An error occurred while allowing the custom service order.",
            "Allow custom service order": "Allow custom service order",
            "An error occurred while sending the custom service request.":
                "An error occurred while sending the custom service request.",
            "Approve custom service request": "Approve custom service request",
            "An error occurred while approving the custom service request.":
                "An error occurred while approving the custom service request.",
            "An error occurred while declining the custom service request.":
                "An error occurred while declining the custom service request.",
            "Are you sure you want to cancel this custom service?":
                "Are you sure you want to cancel this custom service?",
            "An error occurred while cancelling the custom service.":
                "An error occurred while cancelling the custom service.",
            "Additional service required": "Additional service required",
            "Allow custom additional service order": "Allow custom additional service order",
            "Additional service not needed": "Additional service not needed",
            "Additional service status": "Additional service status",
            "A signed consent document is required for participants with nonstandard samples.":
                "A signed consent document is required for participants with nonstandard samples.",
            "Add at least 1 ready profile file": "Add at least 1 ready profile file",
            Activity: "Activity",
            Additionally: "Additionally",
            "Attach participant identity document": "Attach participant identity document",
            "Attach participant photo": "Attach participant photo",
            "Attach the sample collection protocol": "Attach the sample collection protocol",
            "Attach the sample collection protocol and court ruling":
                "Attach the sample collection protocol and court ruling",
            "Are you sure you want to delete this transfer": "Are you sure you want to delete this transfer",
            "All topics": "All topics",
            Apply: "Apply",

            //B
            /*БИК*/
            "Bank identification code": "Bank Identifier Code",
            Back: "Back",
            "By the tribunal's decision": "By court order",
            Bones: "Bones",
            "Blood plasma": "Blood plasma",
            "Brought by the client": "Brought by the client",
            "By participant on the place": "By participant on the place",
            "BIC must be a number.": "BIC must be a number.",
            "BIC consists of 9 digits.": "BIC consists of 9 digits.",
            "BIC is required to be filled out.": "BIC is required to be filled out.",
            Bill: "Bill",
            Banner: "Banner",
            "Brief information on orders": "Brief information on orders",
            "Base number of participants": "Base number of participants",
            Block: "Block",
            "B24 sync rules": "B24 sync rules",
            "Bitrix fields": "Bitrix fields",
            "B24 field mapping": "B24 field mapping",
            Buttons: "Buttons",
            "Button references": "Button references",
            "B24 Field ID": "B24 Field ID",
            "B24 Field Title": "B24 Field Title",
            "Buttons table": "Buttons table",
            "Buttons description": "Buttons description",
            "B24 fields": "B24 fields",
            "Business processes in B24": "Business processes in B24",

            //C
            "Control panel": "Control panel",
            "Contacts of your personal manager": "Your personal manager contacts",
            Close: "Close",
            Clear: "Clear",
            "Create an article": "Create an article",
            Categories: "Categories",
            "Clear all articles in the trash": "Empty trash",
            Cancel: "Cancel",
            "Cancel adding participant": "Cancel adding participant",
            "Cancel editing participant": "Cancel editing participant",
            "Categories in trash": "Deleted categories",
            "Clear categories and articles from the trash": "Empty trash",
            "Categories and articles have been cleared from the trash": "Trash has been cleared",
            "Clear all categories and their nested articles in the trash": "Trash has been cleared",
            Category: "Category",
            Choose: "Choose",
            "Checking account": "Checking account",
            "Correspondent account": "Correspondent account",
            "Choose from all types of tests": "Choose from all types of tests",
            "Copy of the conclusion": "Conclusion copy",
            Check: "Check",
            "Confirm file deletion": "Confirm file deletion",
            Confirm: "Confirm",
            "Contact email": "Contact email",
            "Creating a user": "Creating a user",
            "Current photo": "Current photo",
            Checkout: "Checkout",
            "Comparison of DNA profiles": "Comparison of DNA profiles",
            "Confirm deletion": "Confirm deletion",
            Child: "Child",
            "Chewing gum": "Chewing gum",
            "Cigarette butts": "Cigarette butts",
            Comb: "Comb",
            "current total size": "current total size",
            "Current data": "Current data",
            "Content manager": "Content manager",
            "Confirm partner company data": "Confirm partner company data",
            "Confirm data": "Confirm data",
            "Change user data": "Change user data",
            "Create new appeal": "Create new appeal",
            Created: "Created",
            Correspondence: "Correspondence",
            "Change status": "Change status",
            "Clear tests in trash": "Clear tests in trash",
            "Contact phone": "Contact phone",
            Call: "Call",
            "Clear the filters": "Clear the filters",
            "Clear the sorting": "Clear the sorting",
            "Current preview": "Current preview",
            "Confirm the deletion": "Confirm the deletion",
            "Contacts can't be empty": "Contacts can't be empty",
            "Current documents": "Current documents",
            "Clear the form with the participant": "Clear the form with the participant",
            Create: "Create",
            "Comments on all samples": "Comments on all samples",
            "Company phone": "Company phone",
            "Courier service": "Courier service",
            "Current address": "Current address",
            "Current phones": "Current phones",
            "Call a courier": "Call a courier",
            "Create a slide": "Create a slide",
            "Create an appeal for the order": "Create an appeal for the order",
            "Closing date": "Closing date",
            "Current permission": "Current permission",
            "Create a new ticket status": "Create a new ticket status",
            "Create new urgency": "Create new urgency",
            "Create new ticket type": "Create new ticket type",
            "Create a new standard": "Create a new standard",
            "Creating a new standard": "Creating a new standard",
            "Calculating the price": "Calculating the price",
            "Completed orders": "Completed orders",
            "Completion deadline": "Completion deadline",
            "Completed in days": "Completed in {days, plural, one {# day} other {--- days}}.",
            "Creating an appeal on behalf of the partner": "Creating an appeal on behalf of the partner",
            "Create a request on behalf of the partner": "Create a request on behalf of the partner",
            "Company name": "Company name",
            "Caller’s phone number": "Caller’s phone number",
            "Create a ticket on behalf of the partner": "Create a ticket on behalf of the partner",
            "Cancel the record": "Cancel the record",
            CEO: "CEO",
            "Company phones": "Company phones",
            Countries: "Countries",
            "Countries with OLF": "Countries with OLF",
            "Countries with requisites": "Countries with requisites",
            Cities: "Cities",
            Country: "Country",
            City: "City",
            "Collection protocol": "Collection protocol",
            "Court ruling": "Court ruling",
            "Court information": "Court information",
            "Categories of samples": "Categories of samples",
            "Clear all": "Clear all",
            "Clear partner form": "Clear partner form",
            "Clear the form": "Clear the form",
            "Can a ready-made profile be used": "Can a ready-made profile be used",
            "Ctrl/Cmd+click opens in a new tab": "Ctrl/Cmd+click opens in a new tab",
            "Collection protocol is missing": "Collection protocol is missing",
            "Court determination is missing": "Court determination is missing",
            "Close templates": "Close templates",
            "Create a new document type": "Create a new document type",
            "Create a new laboratory legal entity": "Create a new laboratory legal entity",
            "Current manager": "Current manager",
            "Create new document status": "Create new document status",
            "Create new error": "Create new error",
            "Create new OLF": "Create new OLF",
            "Create new requisite": "Create new requisite",
            "Create new OLF to requisite rule": "Create new OLF to requisite rule",
            "Create new family step": "Create new family step",
            "Creating new family step": "Creating new family step",
            "Create new attribute selection rule": "Create new attribute selection rule",
            "Creating new attribute selection rule": "Creating new attribute selection rule",
            "Create new attribute rule for N participants":
                "Create new attribute rule for {depth, plural, =0 {N participants} =1 {{depth} participant} few {{depth} participants} many {{depth} participants} other {N participants}}",
            "Creating new attribute rule for N participants":
                "Creating new attribute rule for {depth, plural, =0 {N participants} =1 {{depth} participant} few {{depth} participants} many {{depth} participants} other {N participants}}",
            "Create new survey item": "Create new survey item",
            "Creating new survey item": "Creating new survey item",
            "Create new answer type rule": "Create new answer type rule",
            "Creating new answer type rule": "Creating new answer type rule",
            Comment: "Comment",
            "Create new laboratory question status": "Create new laboratory question status",
            "Create new file meaning": "Create new file meaning",
            "Creating new file meaning": "Creating new file meaning",
            "Create new file extension": "Create new file extension",
            "Creating new file extension": "Creating new file extension",
            Copy: "Copy",
            Copied: "Copied",
            "Create link": "Create link",
            "Create new role": "Create new role",
            "Creating new role": "Creating new role",
            "Create new section": "Create new section",
            "Creating new section": "Creating new section",
            "Create new block": "Create new block",
            "Creating new block": "Creating new block",
            "Create new menu section": "Create new menu section",
            "Creating new menu section": "Creating new menu section",
            "Complete order": "Complete order",
            toComplete: "Complete",
            "Complete the DNA test order": "Complete the DNA test order",
            "Confirmation of the client's visit and sample delivery":
                "Confirmation of the client's visit and sample delivery",
            "Cancel courier": "Cancel courier",
            "Courier canceled successfully": "Courier canceled successfully",
            "Call courier": "Call courier",
            "Clear table": "Clear table",
            "Calculated according to the current addendum.agreement / agreement. If you have any questions, please contact our managers.":
                "calculated according to the current addendum.agreement / agreement. If you have any questions, please contact our managers.",
            "Calculated according to the price list of the laboratory (see the Knowledge Base - Price list for the client)":
                "calculated according to the price list of the laboratory (see the Knowledge Base - Price list for the client)",
            "Clear selection": "Clear selection",
            "Clarifications are required from the partner": "Clarifications are required from the partner",
            "Created by whom": "Created by whom",
            "Created via Client Portal": "Created via Client Portal",
            "Confirmation Requests": "Confirmation Requests",
            "Clients product catalog": "Client's product catalog",
            "Cache settings": "Cache settings",
            "Changes history": "Changes history",
            "Cannot be calculated": "The price cannot be calculated automatically. Contact your manager",
            "Create new hint": "Create new hint",
            "Creating new hint": "Creating new hint",
            "Change approval": "Change approval",
            "City (Legal Address)": "City (Legal Address)",
            Couriers: "Couriers",
            "Completed courier requests": "Completed courier requests",
            "Call an extra courier": "Call an extra courier",
            "Correct track number": "Correct track number",
            Change: "Change",
            "Change selection": "Change selection",
            "Current responsible manager": "Current responsible manager",
            "Court revoked determination": "Court revoked determination",
            "Civil case number": "Civil case number",
            "Court name": "Court name",
            Continue: "Continue",
            "Consent for nonstandard sample research": "Consent for nonstandard sample research",
            "Custom service order allowed successfully.": "Custom service order allowed successfully.",
            "Custom service request sent successfully.": "Custom service request sent successfully.",
            "Custom service request approved successfully.": "Custom service request approved successfully.",
            "Custom service request declined.": "Custom service request declined.",
            "Custom service cancelled successfully.": "Custom service cancelled successfully.",
            "Custom service decline reason": "Custom service decline reason",
            "Custom service not needed": "Custom service not needed",
            "Client informed": "Client informed",
            "Client declined study": "Client declined study",
            "Change date": "Change date",
            "Change method": "Change method",
            "Changed by": "Changed by",
            "Checksum errors": "Checksum errors",
            "Can't log in? Try to recover your password.": "Can't log in? Try to recover your password.",
            "Current topic": "Current topic",

            //D
            "DNA Tests": "DNA Tests",
            "Date of creation": "Creation date",
            Description: "Description",
            Delete: "Delete",
            "Description of family ties": "Description of family ties",
            "Documents from the laboratory": "Laboratory documents",
            "Dialogue with the laboratory regarding the test": "Contact the laboratory regarding the test",
            "Download the document": "Download the document",
            "Date of birth": "Date of birth",
            "Description of another type of sample": "Another sample type description",
            "Download the file": "Download the file",
            "Delete the file": "Delete the file",
            Deleting: "Deleting",
            Documents: "Documents",
            'DNA Beauty "Beauty"': 'DNA Beauty "Beauty"',
            "Determination of sperm in the material": "Sperm detection in the material",
            "Determination of blood in the material": "Blood detection in the material",
            "Describe another test": "Describe another test",
            "Disposable/cutlery": "Disposable/cutlery",
            "Drinking straw": "Drinking straw",
            "Describe the sample": "Describe the sample",
            "Describe family ties (for relationship tests)": "Describe family ties (for relationship tests)",
            documents: "documents",
            "Date of birth cannot be later than today.": "Date of birth cannot be greater than today.",
            "Degree of relationship is required.": "Degree of relationship is required.",
            "Description for non-standard tests": "Description for non-standard tests",
            "Declared physical address": "Declared physical address",
            "Declared contact": "Declared contact",
            "Do you want to call a courier to collect biomaterial?":
                "Do you want to call a courier to collect biomaterial?",
            "Degrees of relationship are loading": "Degrees of relationship are loading",
            "Dates for the end customer": "Dates for the end customer",
            "Date of sample collection": "Date of sample collection",
            "Document types are loading": "Document types are loading",
            "Document number is required": "Document number is required",
            "Document number": "Document number",
            "Delivery address": "Delivery address",
            "Delivery created": "Delivery created",
            "Delivery status": "Delivery status",
            "Document status": "Document status",
            Days: "Days",
            "Deleting status": "Deleting status",
            "Deleting urgency": "Deleting urgency",
            "Deleting value": "Deleting value",
            "Deleting the ticket type": "Deleting the ticket type",
            "Deal items": "Deal items",
            "Deadline for completing the test": "Deadline for completing the test",
            "Date of payment or receipt": "Date of payment or receipt",
            "Debt on payments": "Debt on payments",
            'Date of transition to "in progress" status': 'Date of transition to "in progress" status',
            'Date of transition to "ready" status': 'Date of transition to "ready" status',
            'Date of transition to "stopped" status': 'Date of transition to "stopped" status',
            "Duration of execution in days": "Duration of execution in days",
            "Duration (days)": "Duration (days)",
            "Decline and suggest slots": "Decline and suggest slots",
            "Date of study": "Date of study",
            "Date of account creation": "Date of account creation",
            "Displayed on the website": "Displayed on the website",
            "Degrees of relationship": "Degrees of relationship",
            "Definition of SKUs": "Definition of SKUs",
            "Date of the last message from a company employee (any user except the partner)":
                "Date of the last message from a company employee (any user except the partner)",
            Date: "Date",
            'Date when moved to the "Issue not resolved" stage': 'Date when moved to the "Issue not resolved" stage',
            Descending: "Descending",
            "Document types": "Document types",
            "Deleting document type": "Deleting document type",
            "Deleting OLF": "Deleting OLF",
            "Deleting requisite": "Deleting requisite",
            "Deleting OLF to requisite rule": "Deleting OLF to requisite rule",
            "Document signing and storage for our legal entities and partners":
                "Document signing and storage for our legal entities and partners",
            "Document statuses": "Document statuses",
            "Deleting legal entity": "Deleting legal entity",
            "Deleting error": "Deleting error",
            "Deleting family step": "Deleting family step",
            "Deleting attribute selection rule": "Deleting attribute selection rule",
            "Deleting attribute rule for N participants":
                "Deleting attribute rule for {depth, plural, =0 {N participants} =1 {{depth} participant} few {{depth} participants} many {{depth} participants} other {N participants}}",
            "Describe kinship scheme survey": '"Describe the kinship scheme" survey',
            "Deleting survey item": "Deleting survey item",
            "Deleting answer type rule": "Deleting answer type rule",
            "Delete display condition": "Delete display condition",
            "Display conditionally": "Display conditionally",
            "Delete rule": "Delete rule",
            "Deleting file meaning": "Deleting file meaning",
            "Deleting file extension": "Deleting file extension",
            "Delete link": "Delete link",
            "Deleting role": "Deleting role",
            "Deleting section": "Deleting section",
            "Deleting menu section": "Deleting menu section",
            "Delete value": "Delete value",
            "Date of article update cannot be later than today": "Date of article update cannot be later than today",
            "Date of registration cannot be later than today": "Date of registration cannot be later than today",
            "Deleting hint": "Deleting hint",
            Descriptions: "Descriptions",
            "Deal status history": "Deal status history",
            "Date of sending the original report": "Date of sending the original report",
            "Decline additional service": "Decline additional service",
            "Describe the custom service you want to order for order":
                "Describe the custom service you want to order for order",
            "Describe what service you need": "Describe what service you need",
            "Decline custom service request": "Decline custom service request",
            "Decline reason": "Decline reason",
            Decline: "Decline",
            "Download consent document": "Download consent document",
            "Describe kinship ties": "Describe kinship ties",
            "Documents and photos": "Documents and photos",
            "Documents and files": "Documents and files",
            "Deleting transfer": "Deleting transfer",

            //E
            Economist: "Economist",
            Entrance: "Log in",
            Email: "Email",
            "Empty articles from trash": "Empty trash",
            "Error with text": "An error occurred on the server. Error text: {error}.",
            "Error with code and text": "An error has occurred on the server. Error code: {code}. Error text: {error}.",
            "Editing the category": "Editing the category",
            Edit: "Edit",
            "Edit the article": "Edit the article",
            "Email to log into your personal account": "Email to log into your personal account",
            "Edit the user": "Edit the user",
            "Editing the user": "Editing the user",
            "Edit the partner": "Edit the partner",
            "Edit test participant": "Edit test participant",
            "Ethnic (male line)": "Ethnic (male line)",
            "Ethnic (female line)": "Ethnic (female line)",
            Earwax: "Earwax",
            "Email is required.": "Email is required.",
            "Email cannot be empty.": "Email cannot be empty.",
            "Employee contacts": "Employee contacts",
            "Edit the test": "Edit the test",
            "Edit the DNA test order": "Edit the DNA test order",
            "Error code": "Error code",
            "End customer": "End customer",
            "Edit the phone": "Edit the phone",
            "Employees' phones": "Employees' phones",
            "Enter phone number manually": "Enter phone number manually",
            "Edit the slide": "Edit the slide",
            Error: "Error",
            "Enable Push notifications in this browser, and you'll be able to instantly receive updates about your orders, support requests, and more. We only send information that is important to you. You can always change this permission later in the settings of this browser.":
                "Enable Push notifications in this browser, and you'll be able to instantly receive updates about your orders, support requests, and more. We only send information that is important to you. You can always change this permission later in the settings of this browser.",
            "Editing status": "Editing status",
            "Editing urgency": "Editing urgency",
            "Editing ticket type": "Editing ticket type",
            "Editing the standard": "Editing the standard",
            "Editing OLF": "Editing OLF",
            "Editing requisite": "Editing requisite",
            "Edit the order": "Edit the order",
            "Editing OLF to requisite rule": "Editing OLF to requisite rule",
            employeesDisclaimer: `We, the undersigned, confirm that:<br/>
                - We are fully familiar with the current version of the rules/SOP for sample collection and the preparation of accompanying documentation.<br/>
                - We have completed the necessary training, possess the methodologies, and commit to fully comply with the specified requirements.`,
            "Export to excel": "Export to excel",
            "Editing document type": "Editing document type",
            "Editing document status": "Editing document status",
            Emoji: "Emoji",
            Errors: "Errors",
            "Editing laboratory legal entity": "Editing laboratory legal entity",
            "Editing error": "Editing error",
            "Editing family step": "Editing family step",
            "Editing attribute selection rule": "Editing attribute selection rule",
            "Editing attribute rule for N participants":
                "Editing attribute rule for {depth, plural, =0 {N participants} =1 {{depth} participant} few {{depth} participants} many {{depth} participants} other {N participants}}",
            "Editing survey item": "Editing survey item",
            "Editing laboratory questions status": "Editing laboratory questions status",
            "Editing answer type rule": "Editing answer type rule",
            "Error loading questions from laboratory": "Error loading questions from laboratory",
            "Editing file meaning": "Editing file meaning",
            "Editing file extension": "Editing file extension",
            "Expiration time (minutes)": "Expiration time (minutes)",
            "Expiration time must be at least 10 minutes": "Expiration time must be at least 10 minutes",
            "Expiration date": "Expiration date",
            Expired: "Expired",
            "Editing role": "Editing role",
            "Editing section": "Editing section",
            "Editing block": "Editing block",
            "Editing menu section": "Editing menu section",
            "End time should be after the start time": "End time should be after the start time",
            "Error types": "Error types",
            "Editing hint": "Editing hint",
            "Enter the reason for declining": "Enter the reason for declining",
            "Enter order number": "Enter order number",

            //F
            Finance: "Finance",
            "Failed to log in. There is an error on the server.": "Failed to login. There was an error on the server.",
            "Failed to load data": "Failed to load data",
            "Feedback from users": "Feedback from users",
            Filled: "Filled",
            "Full name": "Full name",
            Fri: "Fri",
            "Filter by status": "Filter by status",
            "Fresh first": "New first",
            "First with unread replies": "First with unread answers",
            "First with read answers": "First with read answers",
            "from A to Z": "from A to Z",
            "from Z to A": "from Z to A",
            "From A to Z": "From A to Z",
            "From Z to A": "From Z to A",
            "First you need to create categories, then it will be possible to add articles to them":
                "You need to create the category first and then you can add articles",
            "Full name of the legal entity": "Full name of a legal entity",
            "Features of pregnancy": "Pregnancy peculiarities",
            "File name": "File name",
            files: "files",
            "Full name or nickname": "Full name or nickname",
            "File size": "File size",
            "Filter by roles": "Filter by roles",
            From: "From",
            "Full name or legal name": "Full name or legal name",
            "Fetal gender": "Fetal gender",
            "Father's brother": "Father's brother",
            Father: "Father",
            "Father's sister": "Father's sister",
            "Feminine pad/tampon": "Feminine pad/tampon",
            "Features of pregnancy (for pregnant women)": "Pregnancy peculiarities (for pregnant women)",
            "Forms/protocols": "Forms/protocols",
            "File deleted.": "File deleted.",
            "Full name is required.": "Full name is required.",
            "Full name or nickname is required.": "Full name or nickname is required.",
            "Full name cannot be empty.": "Full name cannot be empty.",
            "Full description": "Full description",
            "For employees: if you want partners to be able to order non-standard tests where they write the name themselves, then this list of tests must include a test with the pseudonym: testTypeOther.":
                "For employees: if you want partners to be able to order non-standard tests where they write the name themselves, then this list of tests must include a test with the pseudonym: testTypeOther.",
            "For some reason, the server did not return any roles.":
                "For some reason, the server did not return any roles.",
            "For some reason, the server did not return any managers.":
                "For some reason, the server did not return any managers.",
            "For some reason, the server did not return any partner types.":
                "For some reason, the server did not return any partner types.",
            "For laboratory marks": "For laboratory marks",
            "For laboratory marks for the sample": "For laboratory marks for the sample",
            Files: "Files",
            "From smaller to larger": "From smaller to larger",
            "From larger to smaller": "From larger to smaller",
            "First less": "First less",
            "First more": "First more",
            'Filter by date of transition to "in progress" status':
                'Filter by date of transition to "in progress" status',
            "Filter by deadline date": "Filter by deadline date",
            'Filter by date of transition to "ready" status': 'Filter by date of transition to "ready" status',
            'Filter by date of transition to "stopped" status': 'Filter by date of transition to "stopped" status',
            "Find a partner by TIN": "Find a partner by TIN",
            "Form for creating a ticket": "Form for creating a ticket",
            Filters: "Filters",
            "Fields are not filled(the order is not created) or order data is not confirmed, and calling a courier is not possible":
                "Fields are not filled(the order is not created) or order data is not confirmed, and calling a courier is not possible",
            "Fields are not filled, the order has not been created, and a courier cannot be scheduled.":
                "Fields are not filled, the order has not been created, and a courier cannot be scheduled.",
            Filter: "Filter",
            "Family step": "Kinship step",
            "Family step in question": "Kinship step in question",
            "Family step in doubt": "Family step in doubt",
            "Fill describe kinship scheme survey": "Fill describe kinship scheme survey",
            File: "File",
            "File type": "File type",
            "File meanings": "File meanings",
            "File extensions": "File extensions",
            "Failed to copy password to clipboard": "Failed to copy password to clipboard",
            "From whom": "From whom",
            "Field type": "Field type",
            "Filter by manager": "Filter by manager",
            "First partner message after last manager": "First partner message after last manager",
            "First manager message after last partner": "First manager message after last partner",
            "First manager message after need more time": "First manager message after need more time",
            "Function descriptions": "Function descriptions",
            "Funnels in B24": "Funnels in B24",
            "Fill gestation period": "Fill gestation period",
            "First test type": "First test type",
            "First test types": "First test types",
            "Field in customer account": "Field in customer account",
            "Filter by TIN": "Filter by TIN",
            "Forgot password?": "Forgot password?",
            "Failed to recover password. Please try again.": "Failed to recover password. Please try again.",

            //G
            "Gestational age": "Gestational age",
            "Genetic profile": "Genetic profile",
            "Gilbert's syndrome": "Gilbert's syndrome",
            "Greasy cuffs and/or collars": "Greasy cuffs and/or collars",
            "Gestation period (for pregnant women)": "Gestation period (for pregnant women)",
            "Go back": "Go back",
            "Gender of the participant": "Gender of the participant",
            "Genders are loading": "Genders are loading",
            "Gender is required": "Gender is required",
            "General information on conducting the test": "General information on conducting the test",
            GEO: "GEO",
            "Generate login and password": "Generate login and password",
            "Gestation period in weeks at sample collection": "Gestation period in weeks at sample collection",

            //H
            "Half-sibling on mother's side": "Half-sibling on mother's side",
            "Half-sibling on father's side": "Half-sibling on father's side",
            "Hair with bulb": "Hair with bulb",
            "Histological specimen/paraffin block": "Histological specimen/paraffin block",
            "Handkerchief or napkin with nasal mucus": "Handkerchief or napkin with nasal mucus",
            Hours: "Hours",
            "How many times was it returned to work": "How many times was it returned to work",
            "How many times was it closed": "How many times was it closed",
            "How many times nothing was pressed": "How many times nothing was pressed",
            h: "h",
            "Hide table": "Hide table",
            "Hide password": "Hide password",
            "Handed over to courier": "Handed over to courier",
            "Handed over to courier successfully": "Handed over to courier successfully",
            Hints: "Hints",
            "Hint does not exist": "Hint does not exist",
            "Hint is loading...": "Hint is loading...",
            "Has nested items": "Has nested items",
            Hide: "Hide",
            "Hide additional columns": "Hide additional columns",

            //I
            "Inlab Genetics": "Inlab Genetics",
            Index: "Index",
            Indicators: "Indicators",
            /*ИНН*/
            "Individual taxpayer number": "Individual Taxpayer Identification Number",
            Informational: "Informational",
            "Institution employee": "Institution employee",
            "Informed consent": "Informed consent",
            "Invalid date.": "Invalid date.",
            "Invalid email.": "Invalid email.",
            Image: "Image",
            "If you have a tracking number for the shipment with biological material for this order, please provide it.":
                "If you have a tracking number for the shipment with biological material for this order, please provide it.",
            "Info for a courier": "Info for a courier",
            "Information about participants": "Information about participants",
            "Invoice payment status": "Invoice payment status",
            "Item number": "Item number",
            "Invoice date": "Invoice date",
            "Invoice number": "Invoice number",
            "Invalid value": "Invalid value",
            "Identity document": "Identity document",
            "Identity documents": "Identity documents",
            "Is it possible to add more participants": "Is it possible to add more participants",
            InOrder: "Order",
            "Invalid date": "Invalid date",
            "Identification documents": "Identification documents",
            "If you re-filter, the previous list will be deleted":
                "If you re-filter, the previous list will be deleted",
            "isMultiple is required": "Multiple is required",
            "Initial load": "Initial load",
            "If the provided details match an account, a new password will be sent to your email.":
                "If the provided details match an account, a new password will be sent to your email.",
            Insert: "Insert",

            //J
            "Job title": "Job title",

            //K
            "Knowledge base": "Knowledge base",
            Kb: "Kb",
            Kinship: "Kinship",
            "Kinship scheme": "Kinship scheme",
            "Kinship category": "Kinship category",

            //L
            "Loading...": "Loading…",
            "Log in": "Login",
            "Loading the user": "Loading the user",
            "Loading orders": "Loading orders",
            "Legal status": "Legal status",
            "Loading ordered test types": "Loading ordered test types",
            "Loading categories": "Loading categories",
            "Last modification": "Last modification",
            "Loading managers": "Loading managers",
            'Limited Liability Company "Company Name"': 'Limited Liability Company "Company Name"',
            'LLC "Company Name"': 'LLC "Company Name"',
            "Legal address": "Legal address",
            "Loading roles": "Loading roles",
            "Loading test types": "Loading test types",
            "Loading the order": "Loading the order",
            "Load more": "Load more",
            "Loading senior managers": "Loading senior managers",
            "Loading partners": "Loading partners",
            "Loading available roles": "Loading available roles",
            "Loading users": "Loading users",
            "Liquid blood": "Liquid blood",
            loaded: "loaded",
            Loaded: "Loaded",
            "Loading applications": "Loading applications",
            "Loading the application": "Loading the application",
            "Last update": "Last update",
            "Login is required.": "Login is required.",
            "Legal address is required.": "Legal address is required.",
            "Legal status is required.": "Legal status is required.",
            "Loading articles": "Loading articles",
            "Loading your personal manager": "Loading your personal manager",
            "Loading the appeal": "Loading the appeal",
            Laboratory: "Laboratory",
            "Loading appeals": "Loading appeals",
            "Loading tests": "Loading tests",
            "Loading tests in trash count": "Loading tests in trash count",
            "Legal statuses are loading": "Legal statuses are loading",
            "Loading partner types": "Loading partner types",
            "Loading the module": "Loading the module",
            "Loading slides": "Loading slides",
            Link: "Link",
            "List of tickets for the verified partner created by the current support staff":
                "List of tickets for the verified partner created by the current support staff",
            "Laboratory working hours": "Laboratory working hours",
            "List of slots proposed to the manager": "List of slots proposed to the manager",
            "List of partner employees who have studied/not studied this article":
                "List of partner employees who have studied/not studied this article",
            Learn: "Learn",
            "List of employees who have studied this article": "List of employees who have studied this article",
            "Loading legal statuses": "Loading legal statuses",
            "Link to the appeal": "Link to the appeal",
            "Legal status is not filled": "Legal status is not filled",
            "Laboratory legal entities": "Laboratory legal entities",
            "Legal Forms by Country": "Legal Forms by Country",
            "Legal requisites": "Legal requisites",
            "Lab Partner Questions": "Lab Partner Questions",
            "Laboratory questions statuses": "Laboratory questions statuses",
            "Laboratory Clarifications": "Laboratory Clarifications",
            "Login as this user": "Login as this user",
            "Login as the user": "Login as the user",
            "Login must be at least characters long": "Login must be at least {length} characters long",
            Login: "Login",
            "Link deleted successfully": "Link deleted successfully",
            "Link created successfully": "Link created successfully",
            Logout: "Logout",
            "Last message date": "Last message date",
            Lists: "Lists",
            Location: "Location",
            "Location description": "Location description",
            "List of B24 fields used in LK": "List of B24 fields used in LK",
            "Login as partner": "Login as partner",
            "Last partner message date and time": "Last partner message date and time",
            "Last manager message date and time": "Last manager message date and time",
            Loading: "Loading",

            //M
            "My Orders": "My Orders",
            More: "More",
            Mon: "Mon",
            Message: "Message",
            "Maximum size": "Maximum size",
            Mb: "Mb",
            /*ОГРН*/
            "Main state registration number": "Primary State Registration Number",
            Main: "Main",
            "Maximum size of all files at once": "Maximum size of all files at once",
            Manager: "Manager",
            Managers: "Managers",
            mtDNA: "mtDNA",
            Motherhood: "Motherhood",
            'My Genes "Light"': 'My Genes "Light"',
            'My Genes "Figure"': 'My Genes "Figure"',
            'My Genes "Neurotype"': 'My Genes "Neurotype"',
            'My Genes "Full Health"': 'My Genes "Full Health"',
            "Maternal grandmother": "Maternal grandmother",
            "Mother's brother": "Mother's brother",
            "Maternal grandfather": "Maternal grandfather",
            Mother: "Mother",
            "Mother's sister": "Mother's sister",
            "Mugs and glasses": "Mugs and glasses",
            maximum: "maximum",
            "Message subject": "Message subject",
            "Message text": "Message text",
            "Maximum overall size": "Maximum overall size",
            "Minimum date: 01/01/1900.": "Minimum date: 01/01/1900.",
            "Minimum date: 01/01/currentYear.": "Minimum date: 01/01/{year}.",
            "Maximum date: month/day/year": "Maximum date: {month}/{day}/{year}.",
            "Maximum date exceeded": "Maximum date exceeded",
            "Main state registration number is required.": "Primary State Registration Number is required.",
            "Main state registration number must be a number.": "Primary State Registration Number must be a number.",
            "Main state registration number consists of 13 digits.":
                "Primary State Registration Number consists of 13 digits.",
            "Main info": "Main info",
            "Mailing address": "Mailing address",
            "Manage phones": "Manage phones",
            Minutes: "Minutes",
            "Make it non-working": "Make it non-working",
            Monday: "Monday",
            Mobile: "Mobile",
            "Manage samples": "Manage samples",
            "Minimum number of participants for this test": "Minimum number of participants for this test",
            "Maximum number of participants for this test": "Maximum number of participants for this test",
            "Minimum number of samples for every participant": "Minimum number of samples for every participant",
            "Message id": "Message id",
            m: "m",
            "Manager response date": "Manager response date",
            "Massive manager replacement among partners": "Massive manager replacement among partners",
            Multiple: "Multiple",
            "Manual list": "Manual list",
            "My answer": "My answer",
            "Multiple answers": "Multiple answers",
            Menu: "Menu",
            "Massive mailing": "Massive mailing",
            "Migration rules": "Migration rules",
            "Max number of participants": "Max number of participants",
            "Min number of participants": "Min number of participants",
            "Manager from": "Manager from",
            "Manager to": "Manager to",
            "Mark as unread": "Mark as unread",

            //N
            "Not chosen": "Not chosen",
            No: "No",
            "Name of category": "Category title",
            "Name for the article": "Article title",
            "Name of the bank": "Bank name",
            Note: "Note",
            Needed: "Needed",
            "Not needed": "Not needed",
            "Number by order": "Number by order",
            Next: "Next",
            "NIPT Veracity (3 pathologies)": "NIPT Veracity (3 pathologies)",
            "NIPT Veracity (8 pathologies)": "NIPT Veracity (8 pathologies)",
            "NIPT Veracity (12 pathologies)": "NIPT Veracity (12 pathologies)",
            "NIPT VeraGen (12 pathologies + 100 monogenic)": "NIPT VeraGen (12 pathologies + 100 monogenic)",
            Nationality: "Nationality",
            Nephew: "Nephew",
            Niece: "Niece",
            Nails: "Nails",
            "New data": "New data",
            New: "New",
            "Nested categories of articles": "Nested categories of articles",
            "No search results": "No search results",
            "No physical addresses": "No physical addresses",
            "No tests": "No tests",
            "No data": "No data",
            Name: "Name",
            "New preview": "New preview",
            "No preview for this test": "No preview for this test",
            "Number in Bitrix": "Number in Bitrix",
            "Number of the order in Bitrix": "Number of the order in Bitrix",
            "Number of the document": "Number of the document",
            "No physical address found": "No physical address found",
            "No required phone": "No required phone",
            "No files selected": "No files selected",
            "New status": "New status",
            "New urgency": "New urgency",
            "New ticket type": "New ticket type",
            "New orders": "New orders",
            "Nothing found": "Nothing found",
            "No slot was suitable for the individual": "No slot was suitable for the individual",
            "Number of confirmed transactions": "Number of confirmed transactions",
            "No phone added": "No phone added",
            "No samples selected": "No samples selected",
            "Number of basic participants": "Number of basic participants",
            "Number of inquiries within the sample": "Number of inquiries within the sample",
            "New document type": "New document type",
            "New document status": "New document status",
            "New laboratory legal entity": "New laboratory legal entity",
            "New error": "New error",
            "New OLF": "New OLF",
            "New requisite": "New requisite",
            "New OLF to requisite rule": "New OLF to requisite rule",
            "Number of participants": "Number of participants",
            "New answer type rule": "New answer type rule",
            "New laboratory questions status": "New laboratory questions status",
            "No questions from laboratory": "No questions from laboratory",
            "No rules found for display condition": "No rules found for display condition",
            "No options": "No options",
            "No link": "No link",
            "Number of samples": "Number of samples",
            Notifications: "Notifications",
            "No description": "No description",
            "Not available for the selected combination of degrees of kinship of the participants":
                "Not available for the selected combination of degrees of kinship of the participants",
            "No matching categories found": "No matching categories found",
            "No available actions": "No available actions",
            "Nonstandard sample consent request": "Nonstandard sample consent request",
            "No name": "No name",
            "No templates found": "No templates found",
            "Not filled": "Not filled",
            "No questions about the order": "No questions about the order",
            "New parent": "New parent",
            "No child topics": "No child topics",
            "No topics found": "No topics found",

            //O
            "Order number": "Order number",
            Open: "Open",
            "Open dialog": "Open dialog",
            "Old first": "Old first",
            "Open the order": "Open the order",
            "Order for DNA testing": "Order for DNA testing",
            "Other important information for the laboratory": "Other important information for the laboratory",
            "Order creation date": "Order creation date",
            Other: "Other",
            "Order ID": "Order ID",
            "Order a DNA test": "Order a DNA test",
            "Order a paper conclusion": "Order a paper conclusion",
            "Origin of the family": "Origin of the family",
            "Oral swab (buccal epithelium)": "Oral swab (buccal epithelium)",
            "Order the test": "Order the test",
            "Open the file": "Open the file",
            "Order ID from Bitrix": "Order ID from Bitrix",
            "Order number in Bitrix": "Order number in Bitrix",
            "Organization phone number": "Organization phone number",
            "Obtaining a paper conclusion": "Obtaining a paper conclusion",
            "Obtaining the partner's physical addresses": "Obtaining the partner's physical addresses",
            "Order payment status": "Order payment status",
            Order: "Order",
            "Orders in work": "Orders in work",
            "Orders with overdue payment": "Orders with overdue payment",
            "Orders halted due to overdue payment": "Orders halted due to overdue payment",
            "Orders with expired readiness deadlines": "Orders with expired readiness deadlines",
            "Order statistics": "Order statistics",
            "Open templates": "Open templates",
            "Overdue time": "Overdue time",
            "Option unavailable for the selected combination of conditions":
                "Option unavailable for the selected combination of conditions",
            "Organizational legal forms": "Organizational legal forms",
            "OLF to Requisite Rules": "OLF to Requisite Rules",
            "OLF ID": "OLF ID",
            "OLF title": "OLF title",
            "OLF alias": "OLF alias",
            "Open in new window": "Open in new window",
            "Orders and appointments": "Orders and appointments",
            "Only one sample is included in the calculation. If it is necessary to study other samples, an additional order will be created, as this is a new test.":
                "Only one sample is included in the calculation. If it is necessary to study other samples, an additional order will be created, as this is a new test.",
            "Order statuses": "Order statuses",
            "Order custom service": "Order custom service",
            "Order form field": "Order form field",
            "Order editing": "Order editing",
            "or provide the civil case number and court name": "or provide the civil case number and court name",
            "Original user": "Original user",
            "Open the list of orders": "Open the list of orders",
            "Orders requiring your attention": "Orders requiring your attention",
            "Open child topics": "Open child topics",
            "Open subtopics": "Open subtopics",
            "Original topic": "Original topic",

            //P
            Pedigrees: "Pedigrees",
            Password: "Password",
            "Place a new order": "Place a new order",
            Phone: "Phone",
            "Parent category": "Parent category",
            "Preview for the article": "Article preview",
            "Physical address": "Physical address",
            Partner: "Partner",
            "Partner ID": "Partner ID",
            "Partner documents attached to the order": "Partner documents attached to the order",
            "Print the document": "Print the document",
            "Previous order number": "Previous order number",
            "Participant ID": "Participant ID",
            "Participant data is not available for printing": "Participant data is not available for printing",
            "Print the file": "Print the file",
            "Partner loading": "Partner loading",
            Profile: "Profile",
            Paternity: "Paternity",
            "Paternity+maternity": "Paternity + maternity",
            "Prenatal fatherhood": "Prenatal fatherhood",
            "Paternal grandmother": "Paternal grandmother",
            "Paternal grandfather": "Paternal grandfather",
            "Participant from an earlier test": "Previous test participant",
            "Previous test order number": "Previous test order number",
            Pacifier: "Pacifier",
            Photo: "Photo",
            "Physical addresses": "Physical addresses",
            Processed: "Processed",
            "Partner name": "Partner name",
            "Page not found": "Page not found",
            "Partner info": "Partner info",
            Price: "Price",
            "Physical addresses can't be empty": "Physical addresses can't be empty",
            "Print all barcodes": "Print all barcodes",
            "Print the barcode": "Print the barcode",
            "Phone number for the courier": "Phone number for the courier",
            "Partner type": "Partner type",
            "Partner wants to pay for the sample, add to the cost":
                "Partner wants to pay for the sample, add to the cost",
            "Pregnancy peculiarities are loading": "Pregnancy peculiarities are loading",
            "Place an order on behalf of a partner": "Place an order on behalf of a partner",
            "Provisional date of recording": "Provisional date of recording",
            "Print the order form": "Print the order form",
            "Phone numbers of physical addresses": "Phone numbers of physical addresses",
            "Processing time": "Processing time",
            "Processing time, seconds": "Processing time, seconds",
            "Price list services are loading": "Price list services are loading",
            "Price to pay the lab": "Price to pay the lab",
            "Price the client pays you": "Price the client pays you",
            Published: "Published",
            "Personal statistics": "Personal statistics",
            "Partner training": "Partner training",
            "Partner trained": "Partner trained",
            "Phone type": "Phone type",
            "Phone code": "Phone code",
            Phones: "Phones",
            "Participant photos": "Participant photos",
            Period: "Period",

            "pre-trial order disclaimer": `
                    If you have chosen a pre-trial test, the following conditions must be met:<br/>
                    1. Each participant must have at least one attached photograph.<br/>
                    2. Each participant must have at least one attached identity document.<br/>
                    3. A collection protocol must be attached to the documents
                `,
            "trial order disclaimer": `
                    If you have chosen a pre-trial/trial test, the following conditions must be met:<br/>
                    1. Each participant must have at least one attached photograph.<br/>
                    2. Each participant must have at least one attached identity document.<br/>
                    3. A collection protocol must be attached to the documents.<br/>
                    4. A court ruling must be attached to the documents.
                `,

            "Price for the sample": "Price for the sample",
            "Please enter the sequence number for the sample": "Please enter the sequence number for the sample",
            "Price calculation is functioning in test and demo mode":
                "Price calculation is functioning in test and demo mode",
            "Please write the reason why you do not accept the response, and attach files if necessary. Then click the submit button.":
                "Please write the reason why you do not accept the response, and attach files if necessary. Then click the submit button.",
            "Parent status": "Parent status",
            "Partner Message Date": "Partner Message Date",
            "Parnter id is absent": "Partner id is absent",
            "Preview (yes/no)": "Preview (yes/no)",
            "Participants family link": "Participants family link",
            Participant: "Participant",
            "Please upload at least one file": "Please upload at least one file",
            "Participants list": "Participants list",
            Process: "Process",
            "Prepared list": "Prepared list",
            "Password must be at least characters long": "Password must be at least {length} characters long",
            "Password copied to clipboard": "Password copied to clipboard",
            Permissions: "Permissions",
            Permission: "Permission",
            "Parent menu section": "Parent menu section",
            "Product catalogs": "Product catalogs",
            "Partners product catalog": "Partner's product catalog",
            "Please select at least 1 partner": "Please select at least 1 partner",
            "Price calculation": "Price calculation",
            "Planned issue date": "Planned issue date",
            "Please be advised, the examination period has changed. Expected issue date:":
                "Please be advised, the examination period has changed. Expected issue date:",
            Partners: "Partners",
            "Participant no show": "Participant no show",
            "Partner fields": "Partner fields",
            "Partner field sync rules": "Partner field sync rules",
            "Partner request text": "Partner request text",
            "Parent order number": "Parent order number",
            Parameters: "Parameters",
            Participants: "Participants",
            "Price must be calculated": "Price must be calculated",
            "Partners to return": "Partners to return",
            "Participant submits samples at another location": "Participant submits samples at another location",
            "Parent topic": "Parent topic",
            "Please try again later": "Please try again later",

            //Q
            "Questions about the order": "Questions about the order",
            "Additional questions": "Additional questions",
            Question: "Question",
            "Question ID": "Question ID",
            "Question creation date": "Question creation date",
            "Questions from laboratory require your attention": "Questions from laboratory require your attention",
            "Questions from laboratory": "Questions from laboratory",
            "Question not found": "Question not found",
            "Question has been answered": "Question has been answered",
            "Question is required": "Question is required",

            //R
            "Requests for change of personal data": "Requests to change personal data",
            Required: "Required",
            "Rows in table": "Rows in table",
            "Register a new partner": "Register a new partner",
            /*КПП*/
            "Registration reason code": "Registration reason code",
            Role: "Role",
            Register: "Register",
            "Return of samples": "Return of samples",
            Result: "Result",
            "Relation degree": "Relation degree",
            "Repeat password": "Repeat password",
            Roles: "Roles",
            "Registration date": "Registration date",
            Razor: "Razor",
            "Ready profile": "Ready profile",
            "Return of samples (only in case of remaining balance)": "Samples return (only in case of remaining)",
            Reject: "Reject",
            "Report an error or complain to a manager": "Report an error or complain to a manager",
            "Request for editing": "Request for editing",
            Reason: "Reason",
            Received: "Received",
            "Push notifications": "Push notifications",
            "Push notifications are not available in your browser":
                "Push notifications are not available in your browser",
            "Reference books": "Reference books",
            "Roles that can set this status": "Roles that can set this status",
            "Remaining to pay": "Remaining to pay",
            "Run import of tests from Bitrix": "Run import of tests from Bitrix",
            "Recordings to partners": "Recordings to partners",
            Ratio: "Ratio",
            "Response accepted (close appeal)": "Response accepted (close appeal)",
            "Reporting and analytics on appeals": "Reporting and analytics on appeals",
            "Research sign is not filled": "Research sign is not filled",
            "Response Time Statistics": "Response Time Statistics",
            "Response time": "Response time",
            Requisites: "Requisites",
            "Requisites by country": "Requisites by country",
            "Rule ID": "Rule ID",
            Rule: "Rule",
            "Requisite ID": "Requisite ID",
            "Requisite title": "Requisite title",
            "Requisite alias": "Requisite alias",
            "Relation list": "Relation list",
            Reply: "Reply",
            "Reply not available - rules not configured": "Reply not available - rules not configured",
            Rules: "Rules",
            "Research sign": "Research sign",
            "Response date": "Response date",
            "Ready profile sign": "Ready profile sign",
            "Reset cache": "Reset cache",
            "Reference book changes": "Reference book changes",
            "Return to original account": "Return to original account",
            Refresh: "Refresh",
            "Responsible manager at creation": "Responsible manager at creation",
            "Read/Unread messages": "Read/Unread messages",
            "Read messages": "Read messages",
            Read: "Read",
            "Redirecting to the new additional service order...": "Redirecting to the new additional service order...",
            "Redirecting to the new custom service order...": "Redirecting to the new custom service order...",
            "Reset changes": "Reset changes",
            Return: "Return",
            "Recover password": "Recover password",
            "Return to login": "Return to login",
            "Responsible roles": "Responsible roles",
            "Result issued": "Result issued",
            "Recently opened": "Recently opened",

            //S
            Schedule: "Schedule",
            Sat: "Sat",
            Sun: "Sun",
            Status: "Status",
            StatusNew: "New",
            StatusInProgress: "In progress",
            StatusReady: "Ready",
            "Select from the types of test you have previously ordered":
                "Select from the test types you have previously ordered",
            StatusClosed: "Closed",
            StatusNewOrder: "New order",
            StatusWaitingVisitDate: "Order not created, waiting for visit date coordination",
            StatusSlotsOffered: "Order not created, slots offered",
            StatusVisitConfirmed: "Order not created, visit confirmed",
            StatusOrderNotCreatedVisitPassed: "Order not created, visit date has passed",
            StatusVisitDoneNoSamples: "Visit completed. Samples NOT received by partner",
            StatusVisitFailed: "Visit failed",
            StatusVisitDoneSamplesReceived: "Visit completed. Samples received by partner",
            StatusOrderCreatedVisitPassed: "Order created, visit date has passed",
            StatusTestRejected: "Test rejected",
            StatusCourierRequested: "Courier request submitted",
            StatusCourierCalled: "Courier called",
            StatusCourierCanceled: "Courier canceled",
            StatusSamplesToCourier: "Samples handed over to courier",
            StatusReceivedWaitingPayment: "Received by laboratory, awaiting payment",
            StatusReceivedInProgress: "Received by laboratory, in progress",
            StatusWaitingClarification: "Waiting for clarification",
            "Sort by creation date": "Sort by creation date",
            "Sort by presence of unread replies": "Sort by unread replies",
            "Sort by alphabet": "Sort by alphabet",
            "Status updating": "Status updating",
            "Search by name": "Search by name",
            "Search by article update date": "Search by article update date",
            "Sort by name": "Sort by name",
            "Sort by date updated": "Sort by date updated",
            Save: "Save",
            "Save changes": "Save changes",
            "Short meaning of the article": "Article summary",
            "Select a manager": "Select a manager",
            "Short name of the legal entity": "Legal entity short name",
            "Study period": "Study period",
            Sign: "Sign",
            "Select a file": "Select a file",
            "show ID": "show ID",
            "Sample type": "Sample type",
            "Select roles": "Select roles",
            "Select photo": "Select photo",
            "Select a senior manager": "Select a senior manager",
            "Select a new photo": "Select a new photo",
            "Select which manager to transfer the partners of the deleted manager to":
                "Select which manager to transfer the partners of the deleted manager to",
            "Select which partner to transfer the orders of the removed partner to":
                "Select which partner to transfer the orders of the removed partner to",
            "Select which senior manager to transfer the managers of the removed senior manager to":
                "Select which senior manager to transfer the managers of the removed senior manager to",
            "Senior manager": "Senior manager",
            "Search by registration date": "Search by registration date",
            "Search by email": "Search by email",
            "Search by full name or legal entity": "Search by full name or legal entity",
            "Step 1: Select a test": "Step 1: Select a test",
            "Step 2: Specify Participants": "Step 2: Specify Participants",
            "Step 3: Advanced": "Step 3: Advanced",
            "Select test type": "Select test type",
            "Standard term according to price list": "Price list standard term",
            "Sample description": "Sample description",
            "Soft tissue (parts of organs/muscles/skin)": "Soft tissue (parts of organs/muscles/skin)",
            "Stains on clothing or fabric": "Stains on clothing or fabric",
            "Sperm on fabric / condom": "Sperm on fabric / condom",
            "Scanned copies of documents": "Scanned copies of documents",
            Send: "Send",
            "Supreme administrator": "Supreme administrator",
            "Short name is required.": "Short name is required.",
            "Select a role": "Select a role",
            "Show categories in trash can": "Show categories in trash can",
            "Select a category": "Select a category",
            Search: "Search",
            "Search results": "Search results",
            "Send with corrections": "Send with corrections",
            "Search articles": "Search articles",
            Subject: "Subject",
            "Search by text": "Search by text",
            "Search by subject": "Search by subject",
            "Sorting by subject": "Sorting by subject",
            "Search by title": "Search by title",
            "Search by TIN or by title": "Search by TIN or by title",
            "Serial number": "Serial number",
            "Short description": "Short description",
            "Show processed appeals too": "Show processed appeals too",
            "Select date": "Select date",
            "Select time of the day": "Select time of the day",
            "Sample types are loading": "Sample types are loading",
            "Select a preview for this test": "Select a preview for this test",
            "Study periods are loading": "Study periods are loading",
            "Select the partner type": "Select the partner type",
            "Something went wrong. Error code:": "Something went wrong. Error code:",
            "Select the partner": "Select the partner",
            "Search by creation date": "Search by creation date",
            "Search by last message date": "Search by last message date",
            "Search by order number": "Search by order number",
            "Search by participant's name": "Search by participant's name",
            "Search by a number in Bitrix": "Search by a number in Bitrix",
            "Search by a number of the order in Bitrix": "Search by a number of the order in Bitrix",
            "Select a partner": "Select a partner",
            "Search by order id": "Search by order id",
            "Select a delivery branch": "Select a delivery branch",
            "Select files to order paper copies": "Select files to order paper copies",
            "Statuses are loading": "Statuses are loading",
            "Select files": "Select files",
            "Sort by ID": "Sort by ID",
            "Sorting by creation date": "Sorting by creation date",
            "Search by closing date": "Search by closing date",
            "Sorting by closing date": "Sorting by closing date",
            "Sorting by working time": "Sorting by working time",
            "Standards for ticket responses": "Standards for ticket responses",
            Standard: "Standard",
            "Services according to the price list": "Services according to the price list",
            "Search by invoice date": "Search by invoice date",
            "Server status": "Server status",
            "Sorting by invoice date": "Sorting by invoice date",
            Sorting: "Sorting",
            Select: "Select",
            Saturday: "Saturday",
            Sunday: "Sunday",
            "Support staff": "Support staff",
            "Start over": "Start over",
            Stationary: "Stationary",
            "Select a country": "Select a country",
            "Select a country first": "Select a country first",
            "Select a city": "Select a city",
            "Suggest slots for the end customer": "Suggest slots for the end customer",
            "Send the slots to the manager": "Send the slots to the manager",
            Statistics: "Statistics",
            "Statistics of recordings to partners": "Statistics of recordings to partners",
            "Studied the article": "Studied the article",
            Sample: "Sample",
            "Sample name": "Sample name",
            "Sample processing order": "Sample processing order",
            "Sample processing priority": "Sample processing priority",
            "Samples are loading": "Samples are loading",
            "Samples info": "Samples info",
            "Save participant data": "Save participant data",
            "Select legal status": "Select legal status",
            "Select an attribute": "Select an attribute",
            "Select research period": "Select research period",
            "Sample types": "Sample types",
            SKU: "SKU",
            "Samples that included into the category": "Samples that included into the category",
            "Study period is not filled": "Study period is not filled",
            "Select a template": "Select a template",
            "Sort direction": "Sort direction",
            "Sort by title": "Sort by title",
            "Sort by alias": "Sort by alias",
            "Sort by active": "Sort by active",
            "Sort by description": "Sort by description",
            "Sort by country": "Sort by country",
            "Select partners": "Select partners",
            "Sort by TIN": "Sort by TIN",
            Schema: "Schema",
            "Sort by status": "Sort by status",
            "Sort by partner": "Sort by partner",
            "Sort by order": "Sort by order",
            "Sort by question creation date": "Sort by question creation date",
            "Sort by question": "Sort by question",
            "Sort by Question ID": "Sort by Question ID",
            "Selected rule no longer exists or was deleted": "Selected rule no longer exists or was deleted",
            "Single answer": "Single answer",
            "Save rules": "{n, plural, =0 {Save rule} =1 {Save rule} other {Save rules}}",
            "Select a prepared list": "Select a prepared list",
            "Select file type": "Select file type",
            "Select all": "Select all",
            "Show table": "Show table",
            "Status change date": "Status change date",
            "Show password": "Show password",
            "signed in as":
                "You are signed in as {name}.\nAre you sure you want to sign out to log in as another user?\nWe recommend opening a private/incognito window instead",
            "Sign in as another user": "Sign in as another user",
            Settings: "Settings",
            Sections: "Sections",
            Section: "Section",
            Submenu: "Submenu",
            "Search by TIN": "Search by TIN",
            Selected: "Selected",
            "Selected orders": "Selected orders",
            "Submitted by the laboratory": "Submitted by the laboratory",
            "Submitted documents": "Submitted documents",
            "Show changes history": "Show changes history",
            "Stages in B24": "Stages in B24",
            "Sent by own courier": "Sent by own courier",
            "Samples not yet handed over": "Samples not yet handed over",
            "Search by legal address": "Search by legal address",
            "Search by manager": "Search by manager",
            Start: "Start",
            Show: "Show",
            "Select subcategory": "Select subcategory",
            "Select kinship scheme": "Select kinship scheme",
            "Selected kinship scheme": "Selected kinship scheme",
            "Select category": "Select category",
            "Save the container record first to be able to add nested items.":
                "Save the container record first to be able to add nested items.",
            "Sync list": "Sync list",
            "Select city": "Select city",
            "Super status": "Super status",
            "Supplement the current appeal": "Supplement the current appeal",
            "Statistics calculation rules": "Statistics calculation rules",
            "Sending original reports": "Sending original reports",
            "Super statuses, statuses, tags and buttons of appeals":
                "Super statuses, statuses, tags and buttons of appeals",
            "Statuses and super statuses": "Statuses and super statuses",
            "Statuses and super statuses table": "Statuses and super statuses table",
            "Statuses and super statuses description": "Statuses and super statuses description",
            "Select additional service": "Select additional service",
            "Select the additional service you want to order for order":
                "Select the additional service you want to order for order",
            "Select a service": "Select a service",
            "Service description": "Service description",
            "Service movement": "Service movement",
            "Smart-processes (SP) in B24": "Smart-processes (SP) in B24",
            "Select First test type": "Select First test type",
            Samples: "Samples",
            "Samples in work": "Samples in work",
            "Samples not in work": "Samples not in work",
            "Search by name or TIN": "Search by name or TIN",
            "Samples not selected": "Samples not selected",
            "Sample is not included in the cost": "Sample is not included in the cost",
            "Search all topics": "Search all topics",
            "Select a topic": "Select a topic",
            subtopics: "subtopics",
            "Show additional columns": "Show additional columns",
            "Service transfers": "Service transfers",

            //T
            "Templates are loading": "Templates are loading",
            Tue: "Tue",
            Thu: "Thu",
            "Type of test": "Type of test",
            "Test participants": "Test participants",
            "There are no orders.": "There are no orders.",
            Test: "Test",
            "This action cannot be undone": "This action cannot be undone",
            "The trash can has been emptied": "The trash can has been emptied",
            "The category was successfully saved": "The category was successfully saved",
            "The category has been successfully updated": "The category has been successfully updated",
            "There are no articles in the selected category": "There are no articles in the selected category",
            "There are no available categories": "There are no available categories",
            'The preview is updated as soon as you select a new picture, i.e. the preview will be updated even if you don\'t click "Save".':
                'The preview is updated as soon as you select a new picture, i.e. the preview will be updated even if you don\'t click "Save".',
            "There is not a single physical address, you must add at least one.":
                "There is not any physical address, you must add at least one.",
            "The partner has been successfully registered. Soon, the partner will receive a letter, on email address, chosen for login with the credentials for enter.":
                "The partner has been successfully registered. Soon, the partner will receive a letter, on email address, chosen for login with the credentials for enter.",
            "Track number of sent samples": "Track number of sent samples",
            "Track number of sending the original report": "Track number of sending the original report",
            "Translation of the conclusion into a foreign language": "Conclusion translation into a foreign language",
            "Test other": "Test other",
            "There are no files.": "There are no files.",
            "The essence of the document": "Subject of the document",
            "The essence of the document is not selected": "Subject of the document is not selected",
            "The user was successfully saved.": "The user was successfully saved.",
            "The user has been successfully updated.": "The user has been successfully updated.",
            "The user was successfully deleted.": "The user was successfully deleted.",
            "Transfer to another partner": "Transfer to another partner",
            To: "To",
            "The partner has been successfully updated.": "The partner has been successfully updated.",
            "Treason test": "Treason test",
            Toothbrush: "Toothbrush",
            Toothpicks: "Toothpicks",
            Teeth: "Teeth",
            "total size up to": "total size up to",
            "The application has already been processed.": "The application has already been processed.",
            "The decision was successfully made.": "The decision was successfully made.",
            "The order for DNA testing has been successfully created.":
                "The order for DNA testing has been successfully created.",
            "The password must not be shorter than 6 characters.":
                "The password must not be shorter than 6 characters.",
            "The password is required.": "The password is required.",
            "The files were successfully uploaded": "The files were successfully uploaded",
            "TIN must be a number.": "TIN must be a number.",
            "The TIN consists of 10 digits.": "The TIN consists of 10 digits.",
            "TIN is required to be filled out.": "TIN is required to be filled out.",
            "The registration reason code must be a number.": "The registration reason code must be a number.",
            "The registration reason code consists of 9 digits.": "The registration reason code consists of 9 digits.",
            "The registration reason code is required to be filled out.":
                "The registration reason code is required to be filled out.",
            "The checking account must be a number.": "The checking account must be a number.",
            "The checking account consists of 20 digits.": "The checking account consists of 20 digits.",
            "The checking account is required to be filled out.": "The checking account is required to be filled out.",
            "The correspondent account must be a number.": "The correspondent account must be a number.",
            "The correspondent account consists of 20 digits.": "The correspondent account consists of 20 digits.",
            "The correspondent account starts with 301.": "The correspondent account starts with 301.",
            "The correspondent account is required to be filled out.":
                "The correspondent account is required to be filled out.",
            "The name of the bank is required to be filled out.": "The name of the bank is required to be filled out.",
            "The sign is required to be filled out.": "The sign is required to be filled out.",
            "The test type is required.": "The test type is required.",
            "The previous order number is required.": "The previous order number is required.",
            "The study period is required to be filled out.": "The study period is required to be filled out.",
            "The description of the sample is required to be filled out.":
                "The description of the sample is required to be filled out.",
            "The sample type is required.": "The sample type is required.",
            "The test description is required.": "The test description is required.",
            'The field "Who collected the samples" is required.': 'The field "Who collected the samples" is required.',
            "The article was successfully saved.": "The article was successfully saved.",
            "The phone cannot be empty.": "The phone cannot be empty.",
            "The physical address cannot be empty.": "The physical address cannot be empty.",
            "There are no nested categories.": "There are no nested categories.",
            "The password must not be shorter than some characters.":
                "The password must not be shorter than {count} characters.",
            "There are unreliable data": "There are unreliable data",
            "Type a new value": "Type a new value",
            "There are no contacts": "There are no contacts",
            "The request performed successfully.": "The request performed successfully.",
            Text: "Text",
            "There are no appeals": "There are no appeals",
            Title: "Title",
            "The new test has been successfully created": "The new test has been successfully created",
            "The test has been successfully updated": "The test has been successfully updated",
            "The test in trash": "The test in trash",
            "Tests in trash": "Tests in trash",
            "Type a complete email": "Type a complete email",
            "The courier was successfully called. Expect.": "The courier was successfully called. Expect.",
            "The opened order": "The opened order",
            "The test data isn't loaded": "The test data isn't loaded",
            "This appeal is closed.": "This appeal is closed.",
            "The order is in trash": "The order is in trash",
            "The order is loading": "The order is loading",
            "The barcodes are fetching": "The barcodes are fetching",
            "The address where the courier should arrive": "The address where the courier should arrive",
            "Type of partner": "Type of partner",
            "This field is required": "This field is required",
            "This field must be a number": "This field must be a number",
            "Time zone": "Time zone",
            "The participant editing/adding form is not empty. Please add/edit the participant or clear the form.":
                "The participant editing/adding form is not empty. Please add/edit the participant or clear the form.",
            Type: "Type",
            "Type of the provided document": "Type of the provided document",
            "The value is incorrect": "The value is incorrect",
            "This document is not available for delivery": "This document is not available for delivery",
            "Track number": "Track number",
            "The date by which the slide should be shown": "The date by which the slide should be shown",
            "The time in seconds that the slide should be visible":
                "The time in seconds that the slide should be visible",
            "The server did not return any slides": "The server did not return any slides",
            "The slide data is loading": "The slide data is loading",
            "This address already has such a phone number": "This address already has such a phone number",
            "To call the courier again, please wait for the current request to be closed":
                "To call the courier again, please wait for the current request to be closed",
            "The tracking number will be available for 24 hours on the order page":
                "The tracking number will be available for 24 hours on the order page",
            "The status of the courier call request": "The status of the courier call request",
            "Topics are loading": "Topics are loading",
            Topic: "Topic",
            "The message must be at least 10 characters long and no longer than 1000 characters":
                "The message must be at least 10 characters long and no longer than 1000 characters",
            "Time has passed since the creation": "Time has passed since the creation",
            "The server returned an empty result": "The server returned an empty result",
            "The message must be no longer than 1000 characters": "The message must be no longer than 1000 characters",
            "This setting only works in this browser": "This setting only works in this browser",
            "Turn on/off notifications": "Turn on/off notifications",
            "The current value can only be changed in the settings of the current browser":
                "The current value can only be changed in the settings of the current browser",
            "The status of the ticket has changed": "The status of the ticket has changed",
            "Ticket types": "Ticket types",
            "Ticket urgency": "Ticket urgency",
            "Ticket statuses": "Ticket statuses",
            "Ticket type": "Ticket type",
            "This section will soon become unavailable. Please use:":
                "This section will soon become unavailable. Please use:",
            "Total orders": "Total orders",
            "The order is overdue": "The order is overdue",
            "The order is stopped": "The order is stopped",
            "The partner's request is taking too long to resolve":
                "The partner's request is taking too long to resolve",
            Tuesday: "Tuesday",
            Thursday: "Thursday",
            "The server did not return any roles": "The server did not return any roles",
            "This field consists of some digits": "This field must consist of {digits} digits",
            "The partner has been successfully verified": "The partner has been successfully verified",
            TIN: "TIN",
            "The status is created automatically when the ticket is created, no one can set it manually":
                "The status is created automatically when the ticket is created, no one can set it manually",
            "Total number of transactions": "Total number of transactions",
            "Total sum": "Total sum",
            "The meeting did not take place": "The meeting did not take place",
            "Visit took place, the samples were not received": "Visit took place, the samples were not received",
            "This article should be studied by the partner's employees":
                "This article should be studied by the partner's employees",
            Trained: "Trained",
            "Title of the article": "Title of the article",
            "There are unread messages": "There are unread messages",
            "There is not a single company phone, at least one needs to be added":
                "There is not a single company phone, at least one needs to be added",
            "Title in English": "Title in English",
            "The partner has confirmed their information": "The partner has confirmed their information",
            "The partner has not confirmed its information or the partner has rejected its information":
                "The partner has not confirmed its information or the partner has rejected its information",
            "Total photos": "Total photos",
            "The survey has been conducted. I confirm the data in the order.":
                "The survey has been conducted. I confirm the data in the order.",
            "The client must be interviewed to determine their needs and the order should be formed based on the information obtained from the client, not on the preliminary information provided by the laboratory.":
                "The client must be interviewed to determine their needs and the order should be formed based on the information obtained from the client, not on the preliminary information provided by the laboratory.",
            "The client survey has been completed": "The client survey has been completed",
            "The client must be informed about the rules for conducting research using non-standard biological DNA samples, notified of the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and agrees to conduct the research.":
                "The client must be informed about the rules for conducting research using non-standard biological DNA samples, notified of the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and agrees to conduct the research.",
            "The Call a courier and Add track number buttons will become available after informing the client about non-standard samples":
                "The Call a courier and Add track number buttons will become available after informing the client about non-standard samples",
            "The Call a courier and Add track number buttons will become available after conducting the survey and informing the client about non-standard samples":
                'The "Call a courier" and "Add track number" buttons will become available after conducting the survey and informing the client about non-standard samples',
            "The partner confirmed that they informed the client about the rules for conducting research using non-standard biological DNA samples. The partner notified the client about the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and received consent to conduct the research. The document signed by the client remains with the partner.":
                "The partner confirmed that they informed the client about the rules for conducting research using non-standard biological DNA samples. The partner notified the client about the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and received consent to conduct the research. The document signed by the client remains with the partner.",
            "The partner interviewed the client, identified the client's needs, and created the order based on information obtained from the client rather than on preliminary information provided by the laboratory.":
                "The partner interviewed the client, identified the client's needs, and created the order based on information obtained from the client rather than on preliminary information provided by the laboratory.",
            Testing: "Testing",
            "The test participant form is not empty. Please return to step 2 and complete the form or clear the form.":
                "The test participant form is not empty. Please return to step 2 and complete the form or clear the form.",
            "To create an order, fill in the required fields:": "To create an order, fill in the required fields:",
            "Template message": "Template message",
            "Time between the last messages": "Time between the last messages",
            "Test is not filled": "Test is not filled",
            "To schedule a courier you must first confirm the order details":
                "To schedule a courier you must first confirm the order details",
            "To select a sample, complete step 1": "To select a sample, complete step 1",
            "Ticket id": "Ticket id",
            "The title must be less than 255 characters": "The title must be less than 255 characters",
            "The alias must be less than 255 characters": "The alias must be less than 255 characters",
            "Time unit": "Time unit",
            "Title must be less than 255 characters": "Title must be less than 255 characters",
            "TIN must be less than 20 characters": "TIN must be less than 20 characters",
            "Template questions": "Template questions",
            "Type is required": "Type is required",
            "Temporary login": "Temporary login",
            "Temporary password": "Temporary password",
            "The client may change test parameters at any time. Make sure the price is calculated correctly according to the price list and verify the pre-order parameters":
                "The client may change test parameters at any time. Make sure the price is calculated correctly according to the price list and verify the pre-order parameters",
            "This menu item has sub-items": "This menu item has sub-items",
            "Types of samples": "Sample types",
            "To assign a single track number to all your selected orders, enter it here":
                "To assign a single track number to all your selected orders, enter it here",
            "This field must be less than 255 characters": "This field must be less than 255 characters",
            "Track number added successfully": "Track number added successfully",
            "The Call a courier and Add track number buttons will become available after conducting the survey":
                'The "Call a courier" and "Add track number" buttons will become available after conducting the survey',
            ToFilter: "Filter",
            "The list is empty": "The list is empty",
            "The mass mailing has been sent successfully": "The mass mailing has been sent successfully",
            "The field will be changed to value. The price may change.":
                'The field "{field}" will be changed to "{value}". The price may change.',
            "The displayed price is preliminary and is based on the test parameters":
                "The displayed price is preliminary and is based on the test parameters provided by the client. Please verify that these parameters match the order details and the information provided by the client at sample submission.",
            "Ticket templates": "Ticket templates",
            "The answer is incomplete, clarifications are required":
                "The answer is incomplete, clarifications are required",
            "There is no answer to the essence of the question": "There is no answer to the essence of the question",
            "To save the order, complete the mandatory steps": "To save the order, complete the mandatory steps",
            "The cache was successfully reset": "The cache was successfully reset",
            "Type at least 3 characters": "Type at least 3 characters",
            "Type at least 10 characters": "Type at least 10 characters",
            "This field is filled in automatically": "This field is filled in automatically",
            "Table fields list": "Table fields list",
            Tags: "Tags",
            "To write a message, use the corresponding button:": "To write a message, use the corresponding button:",
            "Total dialogue lifetime": "Total dialogue lifetime",
            "Tags table": "Tags table",
            "Tags description": "Tags description",
            "This service is not available for the current order parameters":
                "This service is not available for the current order parameters",
            "Test type and order form fields relation": "Test type and order form fields relation",
            "Test parameters": "Test parameters",
            "Test type": "Test type",
            "Test type and order form field relation": "Test type and order form field relation",
            "Temporary partner transfer": "Temporary partner transfer",
            "Transfer to other Manager": "Transfer to other Manager",
            "Transfer date to": "Transfer date to",
            "Transfer date back": "Transfer date back",
            Transfer: "Transfer",
            "TIN is required.": "TIN is required.",
            "Ticket topics": "Ticket topics",
            "There are no topics in this category": "There are no topics in this category",
            "Topic path": "Topic path",
            "Topics could not be loaded": "Topics could not be loaded",
            "Try another search": "Try another search",
            "Topic changes": "Topic changes",

            //U
            Users: "Users",
            "User ID": "User ID",
            "Urgent delivery of the report by courier": "Urgent conclusion delivery by courier",
            Upload: "Upload",
            "Uploading documents": "Uploading documents",
            "Upload files": "Upload files",
            "Uploaded files": "Uploaded files",
            "Uploaded documents": "Uploaded documents",
            Update: "Update",
            "Until the court's decision": "Until the court's decision",
            "Unauthorized user": "Unauthorized user",
            Updated: "Updated",
            "Unfortunately, an error occurred while loading partner types.":
                "Unfortunately, an error occurred while loading partner types.",
            "Unfortunately, an error occurred while loading managers.":
                "Unfortunately, an error occurred while loading managers.",
            "Unfortunately, an error occurred while loading roles for a contact.":
                "Unfortunately, an error occurred while loading roles for a contact.",
            "Unfortunately, roles weren't loaded.": "Unfortunately, roles weren't loaded.",
            Urgency: "Urgency",
            "Urgency is loading": "Urgency is loading",
            "User data": "User data",
            "Unpaid orders": "Unpaid orders",
            Unsubscibe: "Unsubscibe",
            "User is blocked": "User is blocked",
            Use: "Use",
            "Upload photos of test participant.": "Upload photos of test participant.",
            "Upload files of an identity document.": "Upload files of an identity document.",
            "Unable to verify the information in the order — not all fields are filled in":
                "Unable to verify the information in the order — not all fields are filled in",
            "Update data?": "Update data?",
            "Upload the required documents before changing the order status":
                "Upload the required documents before changing the order status",
            "Unread messages": "Unread messages",
            UNread: "UNread",
            "Upload a signed consent document for the participant with a nonstandard sample.":
                "Upload a signed consent document for the participant with a nonstandard sample.",
            "Upload the files of the ready profile": "Upload the files of the ready profile",
            "Use the circle to choose a topic or click a category to browse":
                "Use the circle to choose a topic or click a category to browse",

            //V
            "Valid extensions": "Valid extensions",
            "valid formats": "valid formats",
            Value: "Value",
            "View application": "View application",
            View: "View",
            "Verify the caller as a partner by phone number": "Verify the caller as a partner by phone number",
            Verify: "Verify",
            "Visit took place": "Visit took place",
            "Visit took place successfully": "Visit took place successfully",
            "Value is required": "Value is required",
            "Values are required": "Values are required",
            "Value type": "Value type",
            "Visit took place, determination received": "Visit took place, determination received",

            //W
            Wed: "Wed",
            "Written consultation with a test specialist": "Written consultation with a test specialist",
            "Who collected the samples": "Who collected the samples",
            "What to do with existing orders from this partner?": "What to do with existing orders from this partner?",
            "Watch strap": "Watch strap",
            "Write a message": "Write a message",
            "Who collected samples variants are loading": "Who collected samples variants are loading",
            "When the courier will arrive, time from": "When the courier will arrive, time from",
            "When the courier will arrive, time to": "When the courier will arrive, time to",
            "Was read": "Was read",
            "Working hours": "Working hours",
            "What status should be assigned to the existing tickets instead of the one being deleted?":
                "What status should be assigned to the existing tickets instead of the one being deleted?",
            "What value should be assigned to the existing tickets instead of the one being deleted?":
                "What value should be assigned to the existing tickets instead of the one being deleted?",
            "Working hours from": "Working hours from",
            "Working hours to": "Working hours to",
            "Working hours of employees": "Working hours of employees",
            Wednesday: "Wednesday",
            "Who created the appeal": "Who created the appeal",
            "Write a message on another topic": "Write a message on another topic",
            "When creating an order with a nonstandard sample, you must upload a signed consent document.":
                "When creating an order with a nonstandard sample, you must upload a signed consent document.",

            //X
            "X chromosome": "X chromosome",

            //Y
            "You have successfully logged in. You can go to the section you need.":
                "You have successfully logged in. You can go to the section you need.",
            "You've successfully exited.": "You've successfully logged out.",
            "Your manager": "Your manager",
            Yes: "Yes",
            "You can download up to": "You can download up to",
            "Your profile": "Your profile",
            "Your account roles": "Your account roles",
            "You cannot add more participants.": "You cannot add more participants.",
            "Y chromosome": "Y chromosome",
            "You can upload": "You can upload",
            "You have uploaded the maximum number of files.": "You have uploaded the maximum number of files.",
            "You have exceeded the maximum files upload size.": "You have exceeded the maximum size of uploaded files.",
            "You do not have access to this section.": "You do not have access to this section.",
            "You are making too many requests.": "You are making too many requests.",
            "You cannot add more than {{count}} participants.": "You cannot add more than {{count}} participants.",
            You: "You",
            "You need to choose the type of partner.": "You need to choose the type of partner.",
            "Your application has been accepted. It will appear in the order list within 5-10 minutes, and you will be sent an invoice for payment.":
                "Your application has been accepted. It will appear in the order list within 5-10 minutes, and you will be sent an invoice for payment.",
            "You have not made a decision yet": "You have not made a decision yet",
            "You have enabled push notifications on this device": "You have enabled push notifications on this device",
            "You have disabled push notifications on this device":
                "You have disabled push notifications on this device",
            "You are going to delete the status": "You are going to delete the status",
            "You cannot assign a child as a parent (cyclic dependency)":
                "You cannot assign a child as a parent (cyclic dependency)",
            "You do not have permission to perform this action": "You do not have permission to perform this action",
            "You can't select a date from the past": "You can't select a date from the past",
            "You cannot select a past date": "You cannot select a past date",
            "You have reached the 255 character limit": "You have reached the 255 character limit",
            "You have returned from the order page. The data in the table may have changed. Update the table?":
                "You have returned from the order page. The data in the table may have changed. Update the table?",
            "Your courier track number": "Your courier track number",
            "You are logged in as": "You are logged in as",
            "Your answers": "Your answers",
            "You cannot call a courier. You need to mark the result and/or upload documents for the orders.":
                "You cannot call a courier. You need to mark the result and/or upload documents for the orders.",

            //Z
            "1 day(24 hours)": "1 day (24 hours)",
            "2 days(48 hours)": "2 days (48 hours)",
        },
    },
    ru: {
        translation: {
            //A
            "All Orders": "Все заказы",
            "An error occurred on the server while trying to log out. Reload the page and try again.":
                "При попытке выйти произошла ошибка на сервере. Перезагрузите страницу и попробуйте снова.",
            "Another test": "Другой тест",
            Articles: "Статьи",
            "Articles in trash can": "Статьи в корзине",
            "Add a category": "Добавить категорию",
            "Adding a category": "Добавление категории",
            Add: "Добавить",
            "Articles in the current category and subcategories": "Статей в текущей категории и подкатегориях",
            "Article in the trash can": "Статья в корзине",
            Author: "Автор",
            "Available extensions": "Доступные расширения",
            "Adding of a physical address": "Добавление физического адреса",
            "Adding a contact": "Добавление контакта",
            "An error occurred while saving the partner.": "При сохранении партнера произошла ошибка.",
            "About the partner": "О партнере",
            "Additional information": "Дополнительная информация",
            "Additional services": "Дополнительные услуги",
            Act: "Акт",
            "Add a document": "Добавить документ",
            "Added contacts": "Добавленные контакты",
            "Add a user": "Добавить пользователя",
            "Are you sure you want to delete the user?": "Вы действительно хотите удалить пользователя?",
            Address: "Адрес",
            "Added addresses": "Добавленные адреса",
            "An error occurred while updating the partner.": "При обновлении партнера произошла ошибка.",
            "Add test participant": "Добавить участника теста",
            "Add Photos": "Добавить фотографии",
            "Autosomal markers": "Аутосомные маркеры",
            "Are you sure you want to remove the member": "Вы действительно хотите удалить участника",
            "Additional participant": "Дополнительный участник",
            "Abortive material": "Абортивный материал",
            "Application date": "Дата заявки",
            "Application for change of personal data": "Заявка на смену персональных данных",
            "Access is denied": "Доступ запрещен",
            "Attach a file": "Прикрепить файл",
            Administrator: "Администратор",
            Accountant: "Бухгалтер",
            "An error occured during the request.": "Во время запроса произошла ошибка.",
            "An error occurred during the request.": "Во время запроса произошла ошибка.",
            "Add an address": "Добавить адрес",
            "Add a contact": "Добавить контакт",
            "Account info": "Информация об аккаунте",
            Appeal: "Обращение",
            "Add a test": "Добавить тест",
            Alias: "Псевдоним",
            "Are you sure": "Вы уверены",
            "A file isn't chosen": "Файл не выбран",
            "Attributes are loading": "Атрибуты загружаются",
            "A partner is required": "Необходимо выбрать партнера",
            "Agreed date of recording": "Согласованная дата записи",
            "Agreed date": "Согласованная дата",
            "Appeal types are loading": "Типы обращений загружаются",
            "Add a phone": "Добавить телефон",
            "Additional services are loading": "Дополнительные услуги загружаются",
            Appeals: "Обращения",
            "Appeals are loading": "Обращения загружаются",
            "Appeal ID": "ID обращения",
            "After making a decision, refresh the page for the changes to take effect":
                "После принятия решения обновите страницу, чтобы изменения вступили в силу",
            Agree: "Согласовать",
            "Add the slot": "Добавить слот",
            "Added slots": "Добавленные слоты",
            "Article ID": "ID статьи",
            "Articles studied by the partner's employees": "Статьи, которые изучали сотрудники партнера",
            "Add files": "Добавить файлы",
            "Add test participants": "Добавьте участников теста",
            "Average response time between messages": "Среднее время ответа между сообщениями",
            "Average response time, in minutes": "Среднее время ответа, в минутах",
            "At least one participant has an empty name or nickname":
                "Хотя бы один участник имеет пустое имя или псевдоним",
            "At least one participant has an empty degree of kinship":
                "Хотя бы один участник имеет пустую степень родства",
            "At least one participant has an empty sample type": "Хотя бы один участник имеет пустой тип образца",
            "At least one participant has an empty photo":
                "У каждого участника должна быть загружена хотя бы одна фотография",
            "At least one participant has an empty identity document":
                "У каждого участника должен быть загружен хотя бы один документ, удостоверяющий личность",
            "At least one participant does not have an uploaded ready profile":
                "Хотя бы у одного участника нет загруженного готового профиля",
            Ascending: "По возрастанию",
            "Add range": "Добавить диапазон",
            Active: "Активен",
            "Are you sure you want to delete the requisite": "Вы действительно хотите удалить реквизит",
            "Are you sure you want to delete the OLF": "Вы действительно хотите удалить ОПФ",
            "Are you sure you want to delete the OLF to requisite rule":
                "Вы действительно хотите удалить связь ОПФ с реквизитом",
            "Alias must be less than 255 characters": "Псевдоним должен содержать не более 255 символов",
            "Alias must be unique": "Псевдоним должен быть уникальным",
            "Are you sure you want to delete document type": "Вы уверены, что хотите удалить тип документа",
            "Are you sure you want to delete document status": "Вы уверены, что хотите удалить статус документа",
            "Account roles": "Роли аккаунта",
            "Are you sure you want to delete legal entity": "Вы уверены, что хотите удалить юр.лицо",
            "Are you sure you want to delete error": "Вы уверены, что хотите удалить ошибку",
            "Are you sure you want to delete family step": "Вы уверены, что хотите удалить шаг родства",
            "Attribute selection rules": "Правила выбор признака",
            "Are you sure you want to delete attribute selection rule":
                "Вы уверены, что хотите удалить правило выбора признака",
            "Attribute selection rules for N participants":
                "{depth, plural, =0 {Правила выбора признаков для N участников} one {Правило выбора признака для {depth} участника} few {Правила выбора признаков для {depth} участников} many {Правила выбора признаков для {depth} участников} other {Правила выбора признаков для N участников}}",
            "Are you sure you want to delete attribute rule for N participants":
                "Вы уверены, что хотите удалить правило выбора признака для {depth, plural, =0 {N участников} =1 {{depth} участника} few {{depth} участников} many {{depth} участников} other {N участников}}",
            Answers: "Ответы",
            Answer: "Ответ",
            "At least one answer is required": "Добавьте хотя-бы один ответ",
            "Are you sure you want to delete survey item": "Вы уверены, что хотите удалить элемент анкеты",
            "Answer type rules": "Правила формирования типов ответов",
            "Answer type rule": "Правило формирования типов ответов",
            "Are you sure you want to delete answer type rule":
                "Вы уверены, что хотите удалить правило формирования типа ответа",
            "Add a display condition": "Добавить условие показа",
            "Answer laboratory question for order": "Ответьте на вопрос лаборатории по заказу",
            "Answer date": "Дата ответа",
            "Add rule": "Добавить правило",
            "Add at least 1 value": "Добавьте хотя-бы 1 правило",
            "At least one question is required": "Добавьте хотя бы 1 вопрос",
            "Are you sure you want to delete file meaning": "Вы уверены, что хотите удалить значение файла",
            "Are you sure you want to delete file extension": "Вы уверены, что хотите удалить расширение файла",
            "Admin tools": "Инструменты администратора",
            Access: "Доступы",
            "Are you sure you want to delete role": "Вы уверены, что хотите удалить роль",
            "Are you sure you want to delete section": "Вы уверены, что хотите удалить раздел",
            "Are you sure you want to delete block": "Вы уверены, что хотите удалить блок",
            Actions: "Действия",
            "Are you sure you want to delete menu section": "Вы уверены, что хотите удалить пункт меню",
            Action: "Действие",
            "An error occurred while confirming the visit": "Произошла ошибка во время подтверждения визита",
            "An error occurred while canceling the courier": "Произошла ошибка во время отмены курьера",
            "An error occurred while handing over to courier": "Произошла ошибка во время передачи курьеру",
            "Add track number": "Вписать трек-номер",
            "Are you sure you want to clear the list?": "Вы уверены, что хотите очистить список?",
            "Appeal type": "Тип обращения",
            "Automatic price calculation is under development":
                "Автоматический расчет цены работает в тестовом режиме. Ожидаемые сроки полного и верного расчета цены - конец февраля",
            "Answer is given": "Ответ дан",
            "Analysis order form": "Форма заказа теста",
            "Additional participants": "Дополнительные участники",
            "Add a collection protocol file": "Добавьте протокол забора",
            "Add a court ruling file": "Добавьте определение суда",
            "Are you sure you want to delete hint": "Вы уверены, что хотите удалить подсказку",
            "Awaiting receipt of samples": "Ожидает поступления образцов",
            "A judicial test, recording is possible after receiving the ruling.":
                "Судебный тест, запись возможна после получения определения.",
            "Available buttons": "Доступные кнопки",
            All: "Все",
            "At least one participant has no informed consent uploaded":
                "У каждого участника должно быть загружено хотя бы одно информированное согласие",
            "Additional service": "Дополнительная услуга",
            "Are you sure you want to decline this additional service?":
                "Вы уверены, что хотите отказаться от дополнительной услуги?",
            "Additional service declined successfully.": "Дополнительная услуга успешно отклонена.",
            "An error occurred while declining the additional service.":
                "Произошла ошибка при отказе от дополнительной услуги.",
            "Additional service order created successfully.": "Заказ дополнительной услуги успешно создан.",
            "An error occurred while creating the additional service order.":
                "Произошла ошибка при создании заказа дополнительной услуги.",
            "An error occurred while allowing the custom service order.":
                "Произошла ошибка при разрешении нестандартной услуги.",
            "Allow custom service order": "Разрешить заказ нестандартной услуги",
            "An error occurred while sending the custom service request.":
                "Произошла ошибка при отправке запроса на нестандартную услугу.",
            "Approve custom service request": "Согласовать запрос нестандартной услуги",
            "An error occurred while approving the custom service request.":
                "Произошла ошибка при согласовании запроса нестандартной услуги.",
            "An error occurred while declining the custom service request.":
                "Произошла ошибка при отклонении запроса нестандартной услуги.",
            "Are you sure you want to cancel this custom service?":
                "Вы уверены, что хотите отменить нестандартную услугу?",
            "An error occurred while cancelling the custom service.":
                "Произошла ошибка при отмене нестандартной услуги.",
            "Additional service required": "Необходима дополнительная услуга",
            "Allow custom additional service order": "Разрешить заказ нестандартной доп.услуги",
            "Additional service not needed": "Доп.услуга не требуется",
            "Additional service status": "Статус дополнительной услуги",
            "A signed consent document is required for participants with nonstandard samples.":
                "Для участников с нестандартными образцами необходимо загрузить подписанное согласие.",
            "Add at least 1 ready profile file": "Добавьте хотя бы 1 файл готового профиля",
            Activity: "Активность",
            Additionally: "Дополнительно",
            "Attach participant identity document": "Прикрепите документ, удостоверяющий личность",
            "Attach participant photo": "Прикрепите фотографию участника",
            "Attach the sample collection protocol": "Прикрепите протокол забора образцов",
            "Attach the sample collection protocol and court ruling": "Прикрепите протокол забора и определение суда",
            "Are you sure you want to delete this transfer": "Вы уверены, что хотите удалить этот перенос",
            "All topics": "Все темы",
            Apply: "Применить",

            //B
            /*БИК*/
            "Bank identification code": "Банковский Идентификационный Код",
            Back: "Назад",
            "By the tribunal's decision": "По решению суда",
            Bones: "Кости",
            "Blood plasma": "Плазма крови",
            "Brought by the client": "Принес клиент",
            "By participant on the place": "Участник сам на месте",
            "BIC must be a number.": "БИК должен быть числом.",
            "BIC consists of 9 digits.": "БИК состоит из 9 цифр.",
            "BIC is required to be filled out.": "БИК обязателен для заполнения.",
            Bill: "Счет",
            Banner: "Баннер",
            "Brief information on orders": "Краткая информация по заказам",
            "Base number of participants": "Базовое количество участников",
            Block: "Блок",
            "B24 sync rules": "Правила синхронизации Б24",
            "Bitrix fields": "Поля из Битрикса",
            "B24 field mapping": "Поля из Битрикса",
            Buttons: "Кнопки",
            "Button references": "Справочник кнопок",
            "B24 Field ID": "ID поля в Б24",
            "B24 Field Title": "Название поля в Б24",
            "Buttons table": "Таблица кнопок",
            "Buttons description": "Описание кнопок",
            "B24 fields": "Поля Б24",
            "Business processes in B24": "Бизнес-процессы в Б24",

            //C
            "Control panel": "Панель управления",
            "Contacts of your personal manager": "Контакты вашего персонального менеджера",
            Close: "Закрыть",
            Clear: "Очистить",
            "Create an article": "Создать статью",
            Categories: "Категории",
            "Clear all articles in the trash": "Очистить все статьи в корзине",
            Cancel: "Отмена",
            "Cancel adding participant": "Отменить добавление участника",
            "Cancel editing participant": "Отменить редактирование участника",
            "Categories in trash": "Категорий в корзине",
            "Clear categories and articles from the trash": "Очистить категории и статьи из корзины",
            "Categories and articles have been cleared from the trash": "Категории и статьи были очищены из корзины",
            "Clear all categories and their nested articles in the trash":
                "Очистить все категории и вложенные в них статьи в корзине",
            Category: "Категория",
            Choose: "Выберите",
            "Checking account": "Расчетный счет",
            "Correspondent account": "Корреспондентский счет",
            "Choose from all types of tests": "Выбор из всех видов тестов",
            "Copy of the conclusion": "Копия заключения",
            Check: "Счет",
            "Confirm file deletion": "Подтвердите удаление файла",
            Confirm: "Подтвердить",
            "Contact email": "Контактная электронная почта",
            "Creating a user": "Создание пользователя",
            "Current photo": "Текущее фото",
            Checkout: "Оформить заказ",
            "Comparison of DNA profiles": "Сравнение профилей ДНК",
            "Confirm deletion": "Подтвердите удаление",
            Child: "Ребенок",
            "Chewing gum": "Жевательная резинка",
            "Cigarette butts": "Окурки",
            Comb: "Расческа",
            "current total size": "текущий общий размер",
            "Current data": "Текущие данные",
            "Content manager": "Контент-менеджер",
            "Confirm partner company data": "Подтвердите данные компании партнера",
            "Confirm data": "Подтверждаю данные",
            "Change user data": "Изменить пользовательские данные",
            "Create new appeal": "Создать новое обращение",
            Created: "Создано",
            Correspondence: "Переписка",
            "Change status": "Изменить статус",
            "Clear tests in trash": "Очистить тесты из корзины",
            "Contact phone": "Контактный телефон",
            Call: "Вызвать",
            "Clear the filters": "Очистить фильтры",
            "Clear the sorting": "Очистить сортировку",
            "Current preview": "Текущее превью",
            "Confirm the deletion": "Подтвердите удаление",
            "Contacts can't be empty": "Контакты не могут быть пустыми",
            "Current documents": "Текущие документы",
            "Clear the form with the participant": "Очистить форму с участником",
            Create: "Создать",
            "Comments on all samples": "Комментарии ко всем образцам",
            "Company phone": "Телефон компании",
            "Courier service": "Курьерская служба",
            "Create a slide": "Создать слайд",
            "Current address": "Текущий адрес",
            "Current phones": "Текущие телефоны",
            "Call a courier": "Вызвать курьера",
            "Create an appeal for the order": "Создать обращение по заказу",
            "Closing date": "Дата закрытия",
            "Current permission": "Текущее разрешение",
            "Create a new ticket status": "Создать новый статус для тикета",
            "Create new urgency": "Создать новую срочность",
            "Create new ticket type": "Создать новый тип тикета",
            "Create a new standard": "Создать новый норматив",
            "Creating a new standard": "Создание нового норматива",
            "Calculating the price": "Считаем цену",
            "Completed orders": "Выполненных заказов",
            "Completion deadline": "Срок готовности",
            "Completed in days":
                "Выполняется за {days, plural, one {# день} few {# дня} many {# дней} other {--- дней}}.",
            "Creating an appeal on behalf of the partner": "Создание обращения от имени партнера",
            "Create a request on behalf of the partner": "Создать обращение от имени партнера",
            "Company name": "Название компании",
            "Caller’s phone number": "Номер телефона звонящего",
            "Create a ticket on behalf of the partner": "Создайте тикет от имени партнера",
            CEO: "Директор",
            "Cancel the record": "Отменить запись",
            "Company phones": "Телефоны компании",
            Countries: "Страны",
            "Countries with OLF": "Страны с ОПФ",
            "Countries with requisites": "Страны с реквизитами",
            Cities: "Города",
            Country: "Страна",
            City: "Город",
            "Collection protocol": "Протокол забора",
            "Court ruling": "Определение суда",
            "Court information": "Информация о суде",
            "Categories of samples": "Категории образцов",
            "Clear all": "Очистить все",
            "Clear partner form": "Очистить форму партнера",
            "Clear the form": "Очистить форму",
            "Can a ready-made profile be used": "Можно ли использовать готовый профиль",
            "Ctrl/Cmd+click opens in a new tab": "Ctrl/Cmd+клик открывает в новой вкладке",
            "Collection protocol is missing": "Протокол забора отсутствует",
            "Court determination is missing": "Определение суда отсутствует",
            "Close templates": "Закрыть шаблоны",
            "Create a new document type": "Создать новый тип документа",
            "Create a new laboratory legal entity": "Создать новое юр. лицо лаборатории",
            "Current manager": "Текущий менеджер",
            "Create new document status": "Создать новый статус документа",
            "Create new error": "Создать новую ошибку",
            "Create new OLF": "Создать новую ОПФ",
            "Create new requisite": "Создать новый реквизит",
            "Create new OLF to requisite rule": "Создать правило связи ОПФ и реквизита",
            "Create new family step": "Создать новый шаг родства",
            "Creating new family step": "Создание нового шага родства",
            "Create new attribute selection rule": "Создать новое правило выбор признака",
            "Creating new attribute selection rule": "Создание нового правила выбор признака",
            "Create new attribute rule for N participants":
                "Создать новое правило выбора признака для {depth, plural, =0 {для N участников} =1 {для {depth} участника} few {для {depth} участников} many {для {depth} участников} other {для N участников}}",
            "Creating new attribute rule for N participants":
                "Создание нового правила выбора признака для {depth, plural, =0 {N участников} =1 {{depth} участника} few {{depth} участников} many {{depth} участников} other {N участников}}",
            "Create new survey item": "Создать новый элемент анкеты",
            "Creating new survey item": "Создание нового элемента анкеты",
            "Create new answer type rule": "Создать новое правило формирования типа ответа",
            "Creating new answer type rule": "Создание нового правила формирования типа ответа",
            Comment: "Комментарий",
            "Create new laboratory question status": "Создать новый статус для вопроса лаборатории",
            "Create new file meaning": "Создать новое значение файла",
            "Creating new file meaning": "Создание нового значения файла",
            "Create new file extension": "Создать новое расширение файла",
            "Creating new file extension": "Создание нового расширения файла",
            Copy: "Скопировать",
            Copied: "Скопировано",
            "Copied to clipboard": "Скопировано в буфер обмена",
            "Create link": "Создать ссылку",
            "Create new role": "Создать новую роль",
            "Creating new role": "Создание новой роли",
            "Create new section": "Создать новый раздел",
            "Creating new section": "Создание нового раздела",
            "Create new block": "Создать новый блок",
            "Creating new block": "Создание нового блока",
            "Create new menu section": "Создать новый пункт меню",
            "Creating new menu section": "Создание нового пункта меню",
            "Complete order": "Оформить заказ",
            toComplete: "Оформить",
            "Complete the DNA test order": "Оформить заказ на ДНК-тестирование",
            "Confirmation of the client's visit and sample delivery": "Подтверждение визита и сдачи образцов клиентом",
            "Cancel courier": "Отменить курьера",
            "Courier canceled successfully": "Курьер успешно отменён",
            "Call courier": "Вызвать курьера",
            "Clear table": "Очистить таблицу",
            "Calculated according to the current addendum.agreement / agreement. If you have any questions, please contact our managers.":
                "рассчитывается по действующему доп.соглашению / договору. По вопросам обращайтесь к менеджерам",
            "Calculated according to the price list of the laboratory (see the Knowledge Base - Price list for the client)":
                "рассчитывается по прайс-листу лаборатории (см. База Знаний - Прайс-лист цен для клиента)",
            "Clear selection": "Очистить выделение",
            "Clarifications are required from the partner": "Требуются уточнения от партнера",
            "Created by whom": "Кем создано",
            "Created via Client Portal": "Создано в ЛК",
            "Confirmation Requests": "Заявки на подтверждение",
            "Clients product catalog": "Товарный каталог клиента",
            "Cache settings": "Настройки кеша",
            "Changes history": "История изменений",
            "Cannot be calculated": "Цена не может быть автоматически рассчитана. Обратитесь к менеджеру",
            "Create new hint": "Создать новую подсказку",
            "Creating new hint": "Создание новой подсказки",
            "Change approval": "Согласование изменений",
            "City (Legal Address)": "Город (Юр. адрес)",
            Couriers: "Курьеры",
            "Completed courier requests": "Оформленные заявки на курьера",
            "Call an extra courier": "Вызвать дополнительного курьера",
            "Correct track number": "Скорректировать трек-номер",
            Change: "Изменить",
            "Change selection": "Изменить выбор",
            "Current responsible manager": "Ответственный менеджер на текущий момент",
            "Court revoked determination": "Суд отозвал определение",
            "Civil case number": "Номер гражданского дела",
            "Court name": "Название суда",
            Continue: "Продолжить",
            "Consent for nonstandard sample research": "Согласие на исследование нестандартного образца",
            "Custom service order allowed successfully.": "Нестандартная услуга успешно разрешена.",
            "Custom service request sent successfully.": "Запрос на нестандартную услугу успешно отправлен.",
            "Custom service request approved successfully.": "Запрос нестандартной услуги успешно согласован.",
            "Custom service request declined.": "Запрос нестандартной услуги отклонён.",
            "Custom service cancelled successfully.": "Нестандартная услуга успешно отменена.",
            "Custom service decline reason": "Причина отказа в нестандартной услуге",
            "Custom service not needed": "Доп. услуга не требуется",
            "Client informed": "Клиент проинформирован",
            "Client declined study": "Клиент отказался от исследования",
            "Change date": "Дата внесения изменений",
            "Change method": "Способ внесения изменений",
            "Changed by": "Кто внес изменения",
            "Checksum errors": "Ошибки контрольной суммы",
            "Can't log in? Try to recover your password.": "Не удается войти? Попробуйте восстановить пароль.",
            "Current topic": "Текущая тема",

            //D
            "DNA Tests": "ДНК тесты",
            "Date of creation": "Дата создания",
            Description: "Описание",
            Delete: "Удалить",
            "Description of family ties": "Описание родственных связей",
            "Documents from the laboratory": "Документы от лаборатории",
            "Dialogue with the laboratory regarding the test": "Диалог с лабораторией по тесту",
            "Download the document": "Скачать документ",
            "Date of birth": "Дата рождения",
            "Description of another type of sample": "Описание другого вида образца",
            "Download the file": "Скачать файл",
            "Delete the file": "Удалить файл",
            Deleting: "Удаление",
            Documents: "Документы",
            'DNA Beauty "Beauty"': "DNA Beauty «Красота»",
            "Determination of sperm in the material": "Определение спермы в материале",
            "Determination of blood in the material": "Определение крови в материале",
            "Describe another test": "Опишите другой тест",
            "Disposable/cutlery": "Одноразовые / столовые приборы",
            "Drinking straw": "Питьевая трубочка",
            "Describe the sample": "Опишите образец",
            "Describe family ties (for relationship tests)": "Опишите родственные связи (для тестов на родство)",
            documents: "документов",
            "Date of birth cannot be later than today.": "Дата рождения не может быть позднее, чем сегодня.",
            "Degree of relationship is required.": "Степень родства обязательна для заполнения.",
            "Description for non-standard tests": "Описание для нестандартных тестов",
            "Declared physical address": "Заявленный физический адрес",
            "Declared contact": "Заявленный контакт",
            "Do you want to call a courier to collect biomaterial?": "Хотите вызвать курьера для забора биоматериала?",
            "Degrees of relationship are loading": "Степени родства загружаются",
            "Dates for the end customer": "Даты для конечного заказчика",
            "Date of sample collection": "Дата взятия образца",
            "Document types are loading": "Типы документов загружаются",
            "Document number is required": "Номер документа обязателен",
            "Document number": "Номер документа",
            "Delivery address": "Адрес доставки",
            "Delivery created": "Доставка создана",
            "Delivery status": "Статус доставки",
            "Document status": "Статус документа",
            Days: "Дни",
            "Deleting status": "Удаление статуса",
            "Deleting urgency": "Удаление срочности",
            "Deleting value": "Удаляемое значение",
            "Deleting the ticket type": "Удаление типа тикета",
            "Deadline for completing the test": "Срок завершения теста",
            "Date of payment or receipt": "Дата оплаты или квитанции",
            "Debt on payments": "Долг по оплатам",
            'Date of transition to "in progress" status': 'Дата перехода в статус "в работе"',
            'Date of transition to "ready" status': 'Дата перехода в статус "готово"',
            'Date of transition to "stopped" status': 'Дата перехода в статус "остановлено"',
            "Duration of execution in days": "Длительность выполнения в днях",
            "Duration (days)": "Длительность (дней)",
            "Deal items": "Товары сделки",
            "Decline and suggest slots": "Отклонить и предложить слоты",
            "Date of study": "Дата изучения",
            "Date of account creation": "Дата создания личного кабинета",
            "Displayed on the website": "Отображается на сайте",
            "Degrees of relationship": "Степени родства",
            "Definition of SKUs": "Определение артикулов",
            "Date of the last message from a company employee (any user except the partner)":
                "Дата последнего сообщения от сотрудника компании (любой пользователь, кроме партнера)",
            Date: "Дата",
            'Date when moved to the "Issue not resolved" stage':
                'Дата, когда произошел переход на стадию "Вопрос не решен"',
            Descending: "По убыванию",
            "Document types": "Типы документов",
            "Deleting document type": "Удаление типа документа",
            "Deleting OLF": "Удаление ОПФ",
            "Deleting requisite": "Удаление реквизита",
            "Deleting OLF to requisite rule": "Удаление правила связи ОПФ с реквизитом",
            "Document signing and storage for our legal entities and partners":
                "Подписание и хранение документов наших юр. лиц и партнеров",
            "Document statuses": "Статусы документов",
            "Deleting legal entity": "Удаление юр.лица",
            "Deleting document status": "Удаление статуса документа",
            "Deleting error": "Удаление ошибки",
            "Deleting family step": "Удаление шага родства",
            "Deleting attribute selection rule": "Удаление правила выбор признака",
            "Deleting attribute rule for N participants":
                "Удаление правила выбора признака для {depth, plural, =0 {N участников} =1 {{depth} участника} few {{depth} участников} many {{depth} участников} other {N участников}}",
            "Describe kinship scheme survey": 'Анкета "Опишите схему родства"',
            "Deleting survey item": "Удаление элемента анкеты",
            "Deleting answer type rule": "Удаление правила формирования типа ответа",
            "Delete display condition": "Удалить условие показа",
            "Display conditionally": "Условный показ",
            "Delete rule": "Удалить правило",
            "Deleting file meaning": "Удаление значения файла",
            "Deleting file extension": "Удаление расширения файла",
            "Delete link": "Удалить ссылку",
            "Deleting role": "Удаление роли",
            "Deleting section": "Удаление раздела",
            "Deleting block": "Удаление блока",
            "Deleting menu section": "Удаление пункта меню",
            "Delete value": "Удалить значение",
            "Date of article update cannot be later than today":
                "Дата обновления статьи не может быть позднее сегодняшнего дня",
            "Date of registration cannot be later than today":
                "Дата регистрации не может быть позднее сегодняшнего дня",
            "Deleting hint": "Удаление подсказки",
            Descriptions: "Описания",
            "Deal status history": "Движение сделки",
            "Date of sending the original report": "Дата отправки оригинала заключения",
            "Decline additional service": "Отказаться от дополнительной услуги",
            "Describe the custom service you want to order for order":
                "Опишите нестандартную услугу, которую хотите заказать для заказа",
            "Describe what service you need": "Опишите, какая услуга вам нужна",
            "Decline custom service request": "Отклонить запрос нестандартной услуги",
            "Decline reason": "Причина отказа",
            Decline: "Отклонить",
            "Download consent document": "Скачать документ согласия",
            "Describe kinship ties": "Опишите родственные связи",
            "Documents and photos": "Документы и фото",
            "Documents and files": "Документы и файлы",
            "Deleting transfer": "Удаление переноса",

            //E
            Economist: "Экономист",
            Entrance: "Вход",
            Email: "Электронная почта",
            "Empty articles from trash": "Очистить статьи из корзины",
            "Error with text": "Произошла ошибка на сервере. Текст ошибки: {error}.",
            "Error with code and text": "Произошла ошибка на сервере. Код ошибки: {code}. Текст ошибки: {error}.",
            "Editing the category": "Редактирование категории",
            Edit: "Редактировать",
            "Edit the article": "Редактировать статью",
            "Email to log into your personal account": "Электронная почта для входа в личный кабинет",
            "Edit the user": "Редактировать пользователя",
            "Editing the user": "Редактирование пользователя",
            "Edit the partner": "Редактировать партнера",
            "Edit test participant": "Отредактировать участника теста",
            "Ethnic (male line)": "Этнический (мужская линия)",
            "Ethnic (female line)": "Этнический (женская линия)",
            Earwax: "Ушная сера",
            "Email is required.": "Электронная почта обязательна для заполнения.",
            "Email cannot be empty.": "Электронная почта не может быть пустой.",
            "Employee contacts": "Контакты сотрудников",
            "Edit the test": "Редактировать тест",
            "Edit the DNA test order": "Редактировать заказ на ДНК-тестирование",
            "Error code": "Код ошибки",
            "End customer": "Конечный заказчик",
            "Edit the phone": "Редактирование телефона",
            "Employees' phones": "Телефоны сотрудников",
            "Enter phone number manually": "Введите номер телефона вручную",
            Error: "Ошибка",
            "Enable Push notifications in this browser, and you'll be able to instantly receive updates about your orders, support requests, and more. We only send information that is important to you. You can always change this permission later in the settings of this browser.":
                "Включите Push-уведомления в этом браузере, тогда вы сможете моментально узнавать об изменениях по Вашим заказам, обращениям в поддержку и т.д. Мы присылаем только важную для Вас информацию. Потом изменить это разрешение всегда можно в настройках этого браузера.",
            "Editing status": "Редактирование статуса",
            "Editing urgency": "Редактирование срочности",
            "Editing ticket type": "Редактирование типа тикета",
            "Editing the standard": "Редактирование стандарта",
            "Editing OLF": "Редактирование ОПФ",
            "Editing requisite": "Редактирование реквизита",
            "Edit the slide": "Редактировать слайд",
            "Edit the order": "Редактировать заказ",
            Emoji: "Эмоджи",
            "Editing OLF to requisite rule": "Редактирование правила ОПФ и реквизита",
            employeesDisclaimer: `Мы, ниже подписавшиеся, подтверждаем, что:<br/>
                - Полностью ознакомлены с актуальной редакцией правил/СОП по забору образцов и оформлению сопроводительной документации.<br/>
                - Прошли необходимое обучение, владеем методиками и обязуемся соблюдать указанные требования в полном объёме.`,
            "Export to excel": "Экспорт в excel",
            "Editing document type": "Редактирование типа документа",
            "Editing document status": "Редактирование статуса документа",
            Errors: "Ошибки",
            "Editing laboratory legal entity": "Редактирование юр.лица лаборатории",
            "Editing error": "Редактирование ошибки",
            "Editing family step": "Редактирование шага родства",
            "Editing attribute selection rule": "Редактирование правила выбор признака",
            "Editing attribute rule for N participants":
                "Редактирование правила выбора признака для {depth, plural, =0 {N участников} =1 {{depth} участника} few {{depth} участников} many {{depth} участников} other {N участников}}",
            "Editing survey item": "Редактирование элемента анкеты",
            "Editing laboratory questions status": "Редактирование статуса для вопросов лаборатории",
            "Editing answer type rule": "Редактирование правила формирования типа ответа",
            "Error loading questions from laboratory": "Ошибка загрузки вопросов от лаборатории",
            "Editing file meaning": "Редактирование значения файла",
            "Editing file extension": "Редактирование расширения файла",
            "Expiration time (minutes)": "Срок действия (в минутах)",
            "Expiration time must be at least 10 minutes": "Минимальный срок действия - 10 минут",
            "Expiration date": "Дата истечения срока действия",
            Expired: "Срок действия истёк",
            "Editing role": "Редактирование роли",
            "Editing section": "Редактирование раздела",
            "Editing block": "Редактирование блока",
            "Editing menu section": "Редактирование пункта меню",
            "End time should be after the start time": "Конечное время должно быть после начального времени",
            "Error types": "Виды ошибок",
            "Editing hint": "Редактирование подсказки",
            "Enter the reason for declining": "Введите причину отказа",
            "Enter order number": "Введите номер заказа",

            //F
            Finance: "Финансы",
            "Failed to log in. There is an error on the server.": "Войти не удалось. Ошибка на сервере.",
            "Failed to load data": "Не удалось загрузить данные",
            "Feedback from users": "Обратная связь от пользователей",
            Filled: "Заполнено",
            "Full name": "ФИО",
            Fri: "Пт",
            "Filter by status": "Фильтр по статусу",
            "Fresh first": "Сначала свежие",
            "First with unread replies": "Сначала с НЕ прочитанными ответами",
            "First with read answers": "Сначала с прочитанными ответами",
            "from A to Z": "от А до Я",
            "from Z to A": "от Я до А",
            "From A to Z": "От А до Я",
            "From Z to A": "От Я до А",
            "First you need to create categories, then it will be possible to add articles to them":
                "Сначала нужно создать категории, потом будет возможно добавлять в них статьи",
            "Full name of the legal entity": "Полное наименование юридического лица",
            "Features of pregnancy": "Особенности беременности",
            "File name": "Имя файла",
            files: "файлов",
            "Full name or nickname": "ФИО или псевдоним",
            "File size": "Размер файла",
            "Filter by roles": "Фильтр по ролям",
            From: "От",
            "Full name or legal name": "ФИО или название юридического лица",
            "Fetal gender": "Пол плода",
            "Father's brother": "Брат отца",
            Father: "Отец",
            "Father's sister": "Сестра отца",
            "Feminine pad/tampon": "Женская прокладка / тампон",
            "Features of pregnancy (for pregnant women)": "Особенности беременности (для беременных)",
            "Forms/protocols": "Бланки/протоколы",
            "File deleted.": "Файл удален.",
            "Full name is required.": "Полное наименование обязательно для заполнения.",
            "Full name or nickname is required.": "ФИО или псевдоним обязателен для заполнения.",
            "Full name cannot be empty.": "ФИО не может быть пустым.",
            "Full description": "Полное описание",
            "For employees: if you want partners to be able to order non-standard tests where they write the name themselves, then this list of tests must include a test with the pseudonym: testTypeOther.":
                "Для сотрудников: если вы хотите, чтобы партнеры имели возможность заказывать не стандартные тесты, где они сами пишут название, тогда в этом списке тестов должен быть тест с псевдонимом: testTypeOther.",
            "For some reason, the server did not return any roles.":
                "По какой-то причине сервер не вернул ни одну роль.",
            "For some reason, the server did not return any managers.":
                "По какой-то причине сервер не вернул ни одного менеджера.",
            "For some reason, the server did not return any partner types.":
                "По какой-то причине сервер не вернул ни один тип партнера.",
            "For laboratory marks": "Для лабораторных отметок",
            "For laboratory marks for the sample": "Для лабораторных отметок к образцу",
            Files: "Файлы",
            "From smaller to larger": "От меньшего к большему",
            "From larger to smaller": "От большего к меньшему",
            "First less": "Сначала меньше",
            "First more": "Сначала больше",
            Friday: "Пятница",
            'Filter by date of transition to "in progress" status': 'Фильтр по дате перехода в статус "в работе"',
            "Filter by deadline date": "Фильтр по дате дедлайна",
            'Filter by date of transition to "ready" status': 'Фильтр по дате перехода в статус "готов"',
            'Filter by date of transition to "stopped" status': 'Фильтр по дате перехода в статус "остановлено"',
            "Find a partner by TIN": "Найдите партнера по ИНН",
            "Form for creating a ticket": "Форма для создания тикета",
            Filters: "Фильтры",
            "Fields are not filled(the order is not created) or order data is not confirmed, and calling a courier is not possible":
                "Не заполнены поля(заказ не сформирован) или данные заказа не подтверждены, вызов курьера не возможен",
            "Fields are not filled, the order has not been created, and a courier cannot be scheduled.":
                "Не заполнены поля, заказ не сформирован, вызов курьера не возможен.",
            Filter: "Фильтр",
            "Family step": "Шаг родства",
            "Family step in question": "Шаг родства под вопросом",
            "Family step in doubt": "Шаг под сомнением",
            "Fill describe kinship scheme survey": 'Заполните анкету "Опишите схему родства"',
            File: "Файл",
            "File type": "Тип файла",
            "File meanings": "Значения файлов",
            "File extensions": "Расширения файлов",
            "Failed to copy to clipboard": "Не удалось скопировать в буфер обмена",
            "From whom": "От кого",
            "Field type": "Тип поля",
            "Filter by manager": "Фильтрация по менеджеру",
            "First partner message after last manager":
                "Дата и время первого сообщения партнера, написанного после последнего сообщения менеджера (неважно сколько раз после этого партнер безответно напишет), либо самое первое сообщение партнера, если ответов менеджера еще не было",
            "First manager message after last partner":
                "Дата и время первого сообщения менеджера, написанного после последнего сообщения партнера (неважно сколько раз после этого менеджер безответно напишет), либо текущая дата и время если партнер написал, а менеджер не дал ответ",
            "First manager message after need more time":
                'Дата и время первого сообщения менеджера, написанного после последнего сообщения менеджера созданного при помощи кнопки "решение в процессе, требуется дополнительное время до..."',
            "Function descriptions": "Описание функций",
            "Funnels in B24": "Воронки в Б24",
            "Fill gestation period": "Заполните срок беременности",
            "First test type": "Вид First test",
            "First test types": "Виды First test",
            "Field in customer account": "Поле ЛК",
            "Filter by TIN": "Фильтрация по ИНН",
            "Forgot password?": "Забыли пароль?",
            "Failed to recover password. Please try again.": "Не удалось восстановить пароль. Попробуйте еще раз.",

            //G
            "Gestational age": "Срок беременности",
            "Genetic profile": "Генетический профиль",
            "Gilbert's syndrome": "Синдром Жильбера",
            "Greasy cuffs and/or collars": "Засаленные манжеты и/или вороты",
            "Gestation period (for pregnant women)": "Срок беременности (для беременных)",
            "Go back": "Вернуться",
            "Gender of the participant": "Пол участника",
            "Genders are loading": "Варианты полов загружаются",
            "Gender is required": "Пол обязателен",
            "General information on conducting the test": "Общая информация по проведению теста",
            GEO: "ГЕО",
            "Generate login and password": "Сгенерировать логин и пароль",
            "Gestation period in weeks at sample collection": "Срок беременности в неделях на момент сдачи образцов",

            //H
            "Half-sibling on mother's side": "Полусиблинг по матери",
            "Half-sibling on father's side": "Полусиблинг по отцу",
            "Hair with bulb": "Волосы с луковицей",
            "Histological specimen/paraffin block": "Гистологический образец / парафиновый блок",
            "Handkerchief or napkin with nasal mucus": "Платок или салфетка с носовой слизью",
            Hours: "Часы",
            "How many times was it returned to work": "Сколько раз возвращали в работу",
            "How many times was it closed": "Сколько раз закрывали",
            "How many times nothing was pressed": "Сколько раз не нажимали ничего",
            h: "ч",
            "Hide table": "Спрятать таблицу",
            "Hide password": "Скрыть пароль",
            "Handed over to courier": "Передано курьеру",
            "Handed over to courier successfully": "Успешно передано курьеру",
            Hints: "Подсказки",
            "Hint does not exist": "Подсказки не существует",
            "Hint is loading...": "Подсказка загружается...",
            "Has nested items": "Имеет вложенность",
            Hide: "Скрыть",
            "Hide additional columns": "Спрятать дополнительные колонки",

            //I
            "Inlab Genetics": "Инлаб Генетикс",
            Index: "Главная",
            Indicators: "Показатели",
            /*ИНН*/
            "Individual taxpayer number": "Индивидуальный номер налогоплательщика",
            Informational: "Информационный",
            "Institution employee": "Работник учреждения",
            "Informed consent": "Информированное согласие",
            "Invalid date.": "Неверная дата.",
            "Invalid email.": "Некорректная электронная почта.",
            Image: "Изображение",
            "If you have a tracking number for the shipment with biological material for this order, please provide it.":
                "Если у Вас есть трек-номер отправления с биологическим материалом по данному заказу, укажите его.",
            "Info for a courier": "Информация для курьера",
            "Information about participants": "Сведения об участниках",
            "Invoice payment status": "Статус оплаты счета",
            "Invoice date": "Дата выставления счета",
            "Invoice number": "Номер счета",
            "Item number": "Артикул",
            "Invalid value": "Неверное значение",
            "Identity document": "Документ, удостоверяющий личность",
            "Identity documents": "Документы, удостоверяющие личность",
            "Is it possible to add more participants": "Можно добавить участников",
            InOrder: "Порядок",
            "Invalid date": "Неверная дата",
            "Identification documents": "Документы, удостоверяющие личность",
            "If you re-filter, the previous list will be deleted":
                "При повторной фильтрации предыдущий список будет удален",
            "isMultiple is required": "Множественность обязательная для заполнения",
            "Initial load": "первоначальная загрузка",
            "If the provided details match an account, a new password will be sent to your email.":
                "Если указанная комбинация данных подходит, письмо с новым паролем будет отправлено на ваш email.",
            Insert: "Вставить",

            //J
            "Job title": "Должность",

            //K
            "Knowledge base": "База знаний",
            Kb: "Кб",
            Kinship: "Родство",
            "Kinship scheme": "Схема родства",
            "Kinship category": "Категория родства",

            //L
            "Loading...": "Загрузка...",
            "Log in": "Войти",
            "Loading the user": "Загрузка пользователя",
            "Loading orders": "Загрузка заказов",
            "Legal status": "Юридический статус",
            "Loading ordered test types": "Загрузка заказанных видов теста",
            "Loading categories": "Загрузка категорий",
            "Last modification": "Последнее обновление",
            "Loading managers": "Загрузка менеджеров",
            'Limited Liability Company "Company Name"': 'Общество с ограниченной ответственностью "Название компании"',
            'LLC "Company Name"': 'ООО "Название компании"',
            "Legal address": "Юридический адрес",
            "Loading roles": "Загрузка ролей",
            "Loading test types": "Загрузка видов теста",
            "Loading the order": "Загрузка заказа",
            "Load more": "Загрузить еще",
            "Loading senior managers": "Загрузка старших менеджеров",
            "Loading partners": "Загрузка партнеров",
            "Loading available roles": "Загрузка доступных ролей",
            "Loading users": "Загрузка пользователей",
            "Liquid blood": "Кровь жидкая",
            loaded: "загружено",
            Loaded: "Загружено",
            "Loading applications": "Загрузка заявок",
            "Loading the application": "Загрузка заявки",
            "Last update": "Последнее обновление",
            "Login is required.": "Логин обязателен для заполнения.",
            "Legal address is required.": "Юридический адрес обязателен для заполнения.",
            "Legal status is required.": "Юридический статус обязателен для заполнения.",
            "Loading articles": "Загрузка статей",
            "Loading your personal manager": "Загрузка вашего персонального менеджера",
            "Loading the appeal": "Загрузка обращения",
            Laboratory: "Лаборатория",
            "Loading appeals": "Загрузка обращений",
            "Loading tests": "Загрузка тестов",
            "Loading tests in trash count": "Загрузка количества тестов в корзине",
            "Legal statuses are loading": "Юридические статусы загружаются",
            "Loading partner types": "Загрузка партнерских типов",
            "Loading the module": "Загрузка модуля",
            "Loading slides": "Загрузка слайдов",
            Link: "Ссылка",
            "List of tickets for the verified partner created by the current support staff":
                "Список тикетов по верифицированному партнеру, которые создал текущий сотрудник поддержки",
            "Laboratory working hours": "Рабочее время лаборатории",
            "List of slots proposed to the manager": "Список слотов, предложенных менеджеру",
            "List of partner employees who have studied/not studied this article":
                "Список сотрудников партнера, которые изучили/не изучили данную статью",
            Learn: "Изучить",
            "List of employees who have studied this article": "Список сотрудников, которые изучили данную статью",
            "Loading legal statuses": "Загрузка юридических статусов",
            "Link to the appeal": "Ссылка на обращение",
            "Legal status is not filled": "Юридический статус не заполнен",
            "Laboratory legal entities": "Юр. лица лаборатории",
            "Legal Forms by Country": "Правовые формы по стране",
            "Legal requisites": "Реквизиты юр. лица",
            "Lab Partner Questions": "Вопросы лаборатории партнёрам",
            "Laboratory questions statuses": "Статусы для вопросов лаборатории",
            "Laboratory Clarifications": "Уточнения лаборатории",
            "Login as this user": "Вход от имени этого пользователя",
            "Login as the user": "Вход от имени пользователя",
            "Login must be at least characters long": "Логин должен быть не короче {length} символов",
            Login: "Логин",
            "Link deleted successfully": "Ссылка успешно удалена",
            "Link created successfully": "Ссылка успешно создана",
            Logout: "Выйти",
            "Last message date": "Дата последнего сообщения",
            Lists: "Списки",
            Location: "Местоположение",
            "Location description": "Описание местоположения",
            "List of B24 fields used in LK": "Перечень полей Б24, используемых в ЛК",
            "Login as partner": "Войти под партнёром",
            "Last partner message date and time": "Дата и время последнего сообщения партнера",
            "Last manager message date and time": "Дата и время последнего сообщения менеджера",
            Loading: "Загрузка",

            //M
            "My Orders": "Мои заказы",
            More: "Подробнее",
            Mon: "Пн",
            Message: "Сообщение",
            "Maximum size": "Максимальный размер",
            Mb: "Мб",
            /*ОГРН*/
            "Main state registration number": "Основной государственный регистрационный номер",
            Main: "Основное",
            "Maximum size of all files at once": "Максимальный размер всех файлов за раз",
            Manager: "Менеджер",
            Managers: "Менеджеры",
            mtDNA: "мтДНК",
            Motherhood: "Материнство",
            'My Genes "Light"': "Мои Гены «Лайт»",
            'My Genes "Figure"': "Мои Гены «Фигура»",
            'My Genes "Neurotype"': "Мои Гены «Нейротип»",
            'My Genes "Full Health"': "Мои Гены «Полное здоровье»",
            "Maternal grandmother": "Бабушка по матери",
            "Mother's brother": "Брат матери",
            "Maternal grandfather": "Дедушка по матери",
            Mother: "Мать",
            "Mother's sister": "Сестра матери",
            "Mugs and glasses": "Кружки и стаканчики",
            maximum: "максимум",
            "Message subject": "Тема сообщения",
            "Message text": "Текст сообщения",
            "Maximum overall size": "Максимальный общий размер",
            "Minimum date: 01/01/1900.": "Минимальная дата: 01.01.1900.",
            "Minimum date: 01/01/currentYear.": "Минимальная дата: 01.01.{currentYear}.",
            "Maximum date: month/day/year.": "Максимальная дата: {day}.{month}.{year}.",
            "Maximum date exceeded": "Превышена максимальная дата",
            "Main state registration number is required.": "ОГРН обязателен для заполнения.",
            "Main state registration number must be a number.": "ОГРН должен быть числом.",
            "Main state registration number consists of 13 digits.": "ОГРН состоит из 13 цифр.",
            "Main info": "Основная информация",
            "Mailing address": "Почтовый адрес",
            "Manage phones": "Управление телефонами",
            Minutes: "Минуты",
            "Make it non-working": "Сделать не рабочим",
            Monday: "Понедельник",
            Mobile: "Мобильный",
            "Manage samples": "Управление образцами",
            "Minimum number of participants for this test": "Минимальное количество участников для этого теста",
            "Maximum number of participants for this test": "Максимальное количество участников для этого теста",
            "Minimum number of samples for every participant": "Минимальное количество образцов для каждого участника",
            "Message id": "id сообщения",
            m: "м",
            "Manager response date": "Дата ответа менеджера",
            "Massive manager replacement among partners": "Массовая смена менеджера у партнеров",
            Multiple: "Множественный",
            "Manual list": "Ручной список",
            "My answer": "Мой ответ",
            "Multiple answers": "Несколько ответов",
            Menu: "Меню",
            "Massive mailing": "Массовая рассылка",
            "Migration rules": "Правила миграции",
            "Max number of participants": "Максимальное количество участников",
            "Min number of participants": "Минимальное количество участников",
            "Min number of participants must be less than max number":
                "Минимальное количество участников должно быть меньше максимального",
            "Max number of participants must be greater than min number":
                "Максимальное количество участников должно быть больше минимального",
            "Min number of participants must be less than 100":
                "Минимальное количество участников должно быть меньше 100",
            "Max number of participants must be less than 100":
                "Максимальное количество участников должно быть меньше 100",
            "Manager from": "ОТ менеджера",
            "Manager to": "К менеджеру",
            "Mark as unread": "Пометить как непрочитанное",

            //N
            "Not chosen": "Не выбрано",
            No: "Нет",
            "Name of category": "Название категории",
            "Name for the article": "Название статьи",
            "Name of the bank": "Наименование банка",
            Note: "Примечание",
            Needed: "Нужно",
            "Not needed": "Не нужно",
            "Number by order": "Номер по порядку",
            Next: "Далее",
            "NIPT Veracity (3 pathologies)": "НИПТ Veracity (3 патологии)",
            "NIPT Veracity (8 pathologies)": "НИПТ Veracity (8 патологий)",
            "NIPT Veracity (12 pathologies)": "НИПТ Veracity (12 патологий)",
            "NIPT VeraGen (12 pathologies + 100 monogenic)": "НИПТ VeraGen (12 патологий + 100 моногенных)",
            Nationality: "Национальность",
            Nephew: "Племянник",
            Niece: "Племянница",
            Nails: "Ногти",
            "New data": "Новые данные",
            New: "Новая",
            "Nested categories of articles": "Вложенные категории статей",
            "No search results": "Нет результатов поиска",
            "No physical addresses": "Нет физических адресов",
            "No tests": "Нет тестов",
            "No data": "Нет данных",
            Name: "Имя",
            "New preview": "Новое превью",
            "No preview for this test": "Нет превью для этого теста",
            "Number in Bitrix": "Номер в Битриксе",
            "Number of the order in Bitrix": "Номер заказа в Битриксе",
            "Number of the document": "Номер документа",
            "No physical address found": "Не найдено ни одного физического адреса",
            "No required phone": "Нет нужного телефона",
            "No files selected": "Нет выбранных файлов",
            "New status": "Новый статус",
            "New urgency": "Новая срочность",
            "New ticket type": "Новый тип тикета",
            "New orders": "Новых заказов",
            "Nothing found": "Ничего не найдено",
            "No slot was suitable for the individual": "Физ. лицу не подошел ни один слот",
            "Number of confirmed transactions": "Количество подтвержденных сделок",
            "No phone added": "Нет добавленных телефонов",
            "No samples selected": "Нет выбранных образцов",
            "Number of basic participants": "Количество базовых участников",
            "Number of inquiries within the sample": "Количество обращений в рамках выборки",
            "New document type": "Новый тип документа",
            "New document status": "Новый статус документа",
            "New laboratory legal entity": "Новое юр.лицо лаборатории",
            "New error": "Новая ошибка",
            "New OLF": "Новая ОПФ",
            "New requisite": "Новый реквизит",
            "New OLF to requisite rule": "Новое правило связи ОПФ и реквизита",
            "Number of participants": "Количество участников",
            "New answer type rule": "Новое правило формирования типа ответа",
            "New laboratory questions status": "Новый статус для вопроса лаборатории",
            "No questions from laboratory": "Нет вопросов от лаборатории",
            "No rules found for display condition": "Не найдено правил для условия показа",
            "No options": "Нет вариантов",
            "No link": "Нет ссылки",
            "Number of samples": "Количество образцов",
            Notifications: "Уведомления",
            "No description": "Нет описания",
            "Not available for the selected combination of degrees of kinship of the participants":
                "Недоступно для выбранной комбинации степеней родства участников",
            "No matching categories found": "Не найдено доступных категорий",
            "No available actions": "Нет доступных действий",
            "Nonstandard sample consent request": "Запрос согласия на нестандартный образец",
            "No name": "Нет имени",
            "No templates found": "Шаблоны не найдены",
            "Not filled": "Не заполнено",
            "No questions about the order": "Нет вопросов по заказу",
            "New parent": "Новый родитель",
            "No child topics": "Нет дочерних тем",
            "No topics found": "Темы не найдены",

            //O
            "Order number": "Номер заказа",
            Open: "Открыть",
            "Open dialog": "Открыть диалог",
            "Old first": "Сначала старые",
            "Open the order": "Открыть заказ",
            "Order for DNA testing": "Заказ на ДНК-тестирование",
            "Other important information for the laboratory": "Другая важная для лаборатории информация",
            "Order creation date": "Дата создания заказа",
            Other: "Другое",
            "Order ID": "ID заказа",
            "Order a DNA test": "Заказать ДНК-тест",
            "Order a paper conclusion": "Заказать бумажное заключение",
            "Origin of the family": "Происхождение рода",
            "Oral swab (buccal epithelium)": "Ротовой мазок (буккальный эпителий)",
            "Order the test": "Оформить тест",
            "Open the file": "Открыть файл",
            "Order ID from Bitrix": "ID заказа из Битрикса",
            "Order number in Bitrix": "Номер заказа в Битриксе",
            "Organization phone number": "Телефон организации",
            "Obtaining a paper conclusion": "Получение бумажного заключения",
            "Obtaining the partner's physical addresses": "Получение физических адресов партнера",
            "Order payment status": "Статус оплаты заказа",
            Order: "Заказ",
            "Orders in work": "Заказов в работе",
            "Orders with overdue payment": "Заказов с просрочкой оплаты",
            "Orders halted due to overdue payment": "Заказов, остановленных из-за просрочки",
            "Orders with expired readiness deadlines": "Заказов с истекшим сроком по готовности",
            "Order statistics": "Статистика сделок",
            "Open templates": "Открыть шаблоны",
            "Overdue time": "Превышение норматива",
            "Option unavailable for the selected combination of conditions":
                "Для выбранной комбинации условий вариант недоступен",
            "Organizational legal forms": "Организационно-правовые формы",
            "OLF to Requisite Rules": "Правила связи ОПФ и реквизитов",
            "OLF ID": "ID ОПФ",
            "OLF title": "Название ОПФ",
            "OLF alias": "Псевдоним ОПФ",
            "Open in new window": "Открыть в новом окне",
            "Orders and appointments": "Заказы и записи",
            "Only one sample is included in the calculation. If it is necessary to study other samples, an additional order will be created, as this is a new test.":
                "В расчет включен только один образец, при необходимости исследования других образцов будет создан дополнительный заказ, так как это новый тест",
            "Order statuses": "Статусы заказов",
            "Order custom service": "Заказать нестандартную услугу",
            "Order form field": "Поле формы заказа",
            "Order editing": "Редактирование заказа",
            "or provide the civil case number and court name": "или укажите номер гражданского дела и название суда",
            "Original user": "Изначальный пользователь",
            "Open the list of orders": "Открыть список заказов",
            "Orders requiring your attention": "Заказы, требующие вашего внимания",
            "Open child topics": "Открыть дочерние темы",
            "Open subtopics": "Открыть подтемы",
            "Original topic": "Начальная тема",

            //P
            Pedigrees: "Родословные",
            Password: "Пароль",
            "Place a new order": "Оформить новый заказ",
            Phone: "Телефон",
            "Parent category": "Родительская категория",
            "Preview for the article": "Превью для статьи",
            "Physical address": "Физический адрес",
            Partner: "Партнер",
            "Partner ID": "ID партнера",
            "Partner documents attached to the order": "Документы партнера, прикрепленные к заказу",
            "Print the document": "Распечатать документ",
            "Previous order number": "Номер предыдущего заказа",
            "Participant ID": "ID участника",
            "Participant data is not available for printing": "Данные участника недоступны для печати",
            "Print the file": "Распечатать файл",
            "Partner loading": "Загрузка партнера",
            Profile: "Профиль",
            Paternity: "Отцовство",
            "Paternity+maternity": "Отцовство + материнство",
            "Prenatal fatherhood": "Дородовое отцовство",
            "Paternal grandmother": "Бабушка по отцу",
            "Paternal grandfather": "Дедушка по отцу",
            "Participant from an earlier test": "Участник из более раннего теста",
            "Previous test order number": "Номер заказа предыдущего теста",
            Pacifier: "Соска",
            Photo: "Фото",
            "Physical addresses": "Физические адреса",
            Processed: "Обработана",
            "Partner name": "Название партнера",
            "Page not found": "Страница не найдена",
            "Partner info": "Информация о партнере",
            Price: "Цена",
            "Physical addresses can't be empty": "Физические адреса не могут быть пустыми",
            "Print all barcodes": "Печать всех штрихкодов",
            "Print the barcode": "Печать штрихкода",
            "Phone number for the courier": "Номер телефона для курьера",
            "Partner type": "Тип партнера",
            "Partner wants to pay for the sample, add to the cost":
                "Партнер хочет оплатить образец, добавить в стоимость",
            "Pregnancy peculiarities are loading": "Особенности беременности загружаются",
            "Place an order on behalf of a partner": "Оформить заказ от имени партнера",
            "Provisional date of recording": "Предварительная дата записи",
            "Print the order form": "Печать бланка заказа",
            Published: "Опубликовано",
            "Phone numbers of physical addresses": "Телефоны физических адресов",
            "Processing time": "Времени в обработке",
            "Processing time, seconds": "Время в обработке, секунд",
            "Push notifications": "Push уведомления",
            "Push notifications are not available in your browser": "Push уведомления не доступны в вашем браузере",
            "Price list services are loading": "Услуги по прайс-листу загружаются",
            "Price to pay the lab": "Цена для оплаты в лабораторию от Вас",
            "Price the client pays you": "Цена, которую клиент платит Вам",
            "Personal statistics": "Персональная статистика",
            "Phone type": "Тип телефона",
            "Phone code": "Телефонный код",
            Phones: "Телефоны",
            "Partner training": "Обучение партнеров",
            "Partner trained": "Партнер обучен",
            "Participant photos": "Фотографии участника",
            "pre-trial order disclaimer": `
                    Если вы выбрали досудебный/судебный тест, то должны выполняться следующие условия:<br/>
                    1. У каждого участника должна быть прикреплена хотя бы одна фотография.<br/>
                    2. У каждого участника должен быть прикреплен хотя бы один документ, удостоверяющий личность.<br/>
                    3. К документам должен быть прикреплен протокол забора.
                `,
            "trial order disclaimer": `
                    Если вы выбрали судебный тест, то должны выполняться следующие условия:<br/>
                    1. У каждого участника должна быть прикреплена хотя бы одна фотография.<br/>
                    2. У каждого участника должен быть прикреплен хотя бы один документ, удостоверяющий личность.<br/>
                    3. Необходимо приложить протокол забора и определение суда <br/> 
                    либо внести информацию о гражданском деле и названии суда.
                `,
            "Price for the sample": "Цена за образец",
            "Please enter the sequence number for the sample": "Пожалуйста, введите порядковый номер образца",
            "Price calculation is functioning in test and demo mode":
                "Расчет цены работает в тестовом и ознакомительном режиме",
            "Please write the reason why you do not accept the response, and attach files if necessary. Then click the submit button.":
                "Напишите причину, по которой вы не принимаете ответ, при необходимости прикрепите файлы. После нажмите кнопку отправить.",
            "Parent status": "Родительский статус",
            Period: "Период",
            "Partner Message Date": "Дата сообщения партнера",
            "Parnter id is absent": "ID партнера отсутствует",
            "Preview (yes/no)": "Превью (есть/нет)",
            "Participants family link": "Степень родства участника",
            Participant: "Участник",
            "Please upload at least one file": "Пожалуйста, загрузите хотя-бы 1 файл",
            "Participants list": "Список участников",
            Process: "Процесс",
            "Prepared list": "Готовый список",
            "Password must be at least characters long": "Пароль должен быть не короче {length} символов",
            Permissions: "Разрешения",
            Permission: "Разрешение",
            "Parent menu section": "Родительский пункт меню",
            "Product catalogs": "Товарные каталоги",
            "Partners product catalog": "Товарный каталог партнёра",
            "Please select at least 1 partner": "Пожалуйста, выберите хотя-бы одного партнёра",
            "Price calculation": "Расчёт цены",
            "Planned issue date": "Плановая дата выдачи",
            "Please be advised, the examination period has changed. Expected issue date:":
                "Обратите внимание, срок исследования изменился. Плановая дата выдачи:",
            Partners: "Партнёры",
            "Participant no show": "Неявка участника",
            "Partner fields": "Поля партнёра",
            "Partner field sync rules": "Синхронизация новых партнёров",
            "Partner request text": "Текст запроса партнёра",
            "Parent order number": "Номер основного заказа",
            Parameters: "Параметры",
            Participants: "Участники",
            "Price must be calculated": "Цена должна быть рассчитана",
            "Partners to return": "Партнёров к возврату",
            "Participant submits samples at another location": "Участник сдает образцы в другом месте",
            "Parent topic": "Родительская тема",
            "Please try again later": "Повторите попытку позже",

            //Q
            "Questions about the order": "Вопросы по заказу",
            Quantity: "Количество",
            "Additional questions": "Доп вопросы",
            Question: "Вопрос",
            "Question ID": "ID Вопроса",
            "Question creation date": "Дата создания вопроса",
            "Questions from laboratory require your attention": "Ответьте на вопросы от лаборатории",
            "Questions from laboratory": "Вопросы от лаборатории",
            "Question not found": "Вопрос не найден",
            "Question has been answered": "Ответ на вопрос получен",
            "Question is required": "Вопрос обязателен для заполнения",

            //R
            "Requests for change of personal data": "Заявки на смену персональных данных",
            Required: "Обязательно",
            "Rows in table": "Строк в таблице",
            "Register a new partner": "Зарегистрировать нового партнера",
            /*КПП*/
            "Registration reason code": "Код причины постановки на учет",
            Role: "Роль",
            Register: "Зарегистрировать",
            "Return of samples": "Возврат образцов",
            Result: "Результат",
            "Relation degree": "Степень родства",
            "Repeat password": "Повтор пароля",
            Roles: "Роли",
            "Registration date": "Дата регистрации",
            Razor: "Бритва",
            "Ready profile": "Готовый профиль",
            "Return of samples (only in case of remaining balance)": "Возврат образцов (только в случае остатка)",
            Reject: "Отклонить",
            "Report an error or complain to a manager": "Сообщить об ошибке или пожаловаться руководителю",
            "Request for editing": "Заявка на редактирование",
            "Run import of tests from Bitrix": "Запустить импорт тестов из Битрикса",
            Reason: "Причина",
            Received: "Получено",
            "Reference books": "Справочники",
            "Roles that can set this status": "Роли, которые могут установить этот статус",
            "Remaining to pay": "Осталось оплатить",
            "Recordings to partners": "Записи к партнерам",
            Ratio: "Соотношение",
            "Response accepted (close appeal)": "Ответ принят (закрыть диалог)",
            "Reporting and analytics on appeals": "Отчётность и аналитика по обращениям",
            "Research sign is not filled": "Признак исследования не заполнен",
            "Response Time Statistics": "Статистика по скорости ответа на обращение",
            "Response time": "Время ответа",
            Requisites: "Реквизиты",
            "Requisites by country": "Реквизиты по стране",
            "Rule ID": "ID правила",
            Rule: "Правило",
            "Requisite ID": "ID реквизита",
            "Requisite title": "Название реквизита",
            "Requisite alias": "Псевдоним реквизита",
            "Relation list": "Готовый список",
            Reply: "Ответить",
            "Reply not available - rules not configured": "Ответ недоступен - правила не настроены",
            Rules: "Правила",
            "Research sign": "Признак исследования",
            "Response date": "Дата ответа",
            "Ready profile sign": "Признак готового профиля",
            "Reset cache": "Сбросить кеш",
            "Reference book changes": "Изменение справочников",
            "Return to original account": "Вернуться к изначальному аккаунту",
            Refresh: "Обновить",
            "Responsible manager at creation": "Ответственный менеджер на момент создания обращения",
            "Read/Unread messages": "Прочитанные/Непрочитанные сообщения",
            "Read messages": "Прочитанные сообщения",
            Read: "Прочитано",
            "Redirecting to the new additional service order...": "Перенаправление на новый заказ доп. услуги...",
            "Redirecting to the new custom service order...":
                "Перенаправление на новый заказ нестандартной доп. услуги...",
            "Reset changes": "Сбросить изменения",
            Return: "Возврат",
            "Recover password": "Восстановить пароль",
            "Return to login": "Вернуться ко входу",
            "Responsible roles": "Ответственные роли",
            "Result issued": "Результат выдан",
            "Recently opened": "Недавно открывали",

            //S
            Schedule: "График работы",
            Sat: "Сб",
            Sun: "Вс",
            Status: "Статус",
            StatusNew: "Новый",
            StatusInProgress: "В работе",
            StatusReady: "Готов",
            StatusClosed: "Закрыто",
            StatusNewOrder: "Новый заказ",
            StatusWaitingVisitDate: "Заказ не создан, ждет согласования даты визита",
            StatusSlotsOffered: "Заказ не создан, предложены слоты",
            StatusVisitConfirmed: "Заказ не создан, визит согласован",
            StatusOrderNotCreatedVisitPassed: "Заказ не создан, дата визита прошла",
            StatusVisitDoneNoSamples: "Визит состоялся. Образцы НЕ получены партнером",
            StatusVisitFailed: "Визит не состоялся",
            StatusVisitDoneSamplesReceived: "Визит состоялся. Образцы получены партнером",
            StatusOrderCreatedVisitPassed: "Заказ создан, дата визита прошла",
            StatusTestRejected: "Отказ от теста",
            StatusCourierRequested: "Оформлена заявка на вызов курьера",
            StatusCourierCalled: "Курьер вызван",
            StatusCourierCanceled: "Курьер отменен",
            StatusSamplesToCourier: "Образцы переданы курьеру",
            StatusReceivedWaitingPayment: "Получено лабораторией, ждет оплату",
            StatusReceivedInProgress: "Получено лабораторией, в работе",
            StatusWaitingClarification: "Ждет уточнения",
            "Select from the types of test you have previously ordered": "Выбор из заказанных вами ранее видов теста",
            "Sort by creation date": "Сортировка по дате создания",
            "Sort by presence of unread replies": "Сортировка по наличию НЕ прочитанных ответов",
            "Sort by alphabet": "Сортировка по алфавиту",
            "Status updating": "Обновление статуса",
            "Search by name": "Поиск по названию",
            "Search by article update date": "Поиск по дате обновления статьи",
            "Sort by name": "Сортировка по названию",
            "Sort by date updated": "Сортировка по дате обновления",
            Save: "Сохранить",
            "Save changes": "Сохранить изменения",
            "Short meaning of the article": "Краткий смысл статьи",
            "Select a manager": "Выберите менеджера",
            "Short name of the legal entity": "Краткое наименование юридического лица",
            "Study period": "Срок исследования",
            Sign: "Признак",
            "Select a file": "Выбрать файл",
            "show ID": "показать Id",
            "Sample type": "Вид образца",
            "Select roles": "Выберите роли",
            "Select photo": "Выбрать фото",
            "Select a senior manager": "Выберите старшего менеджера",
            "Select a new photo": "Выбрать новое фото",
            "Select which manager to transfer the partners of the deleted manager to":
                "Выберите к какому менеджеру перенести партнеров удаляемого менеджера",
            "Select which partner to transfer the orders of the removed partner to":
                "Выберите к какому партнеру перенести заказы удаляемого партнера",
            "Select which senior manager to transfer the managers of the removed senior manager to":
                "Выберите к какому старшему менеджеру перенести менеджеров удаляемого старшего менеджера",
            "Senior manager": "Старший менеджер",
            "Search by registration date": "Поиск по дате регистрации",
            "Search by email": "Поиск по электронной почте",
            "Search by full name or legal entity": "Поиск по ФИО или юридическому лицу",
            "Step 1: Select a test": "Шаг 1: Выбор теста",
            "Step 2: Specify Participants": "Шаг 2: Укажите участников",
            "Step 3: Advanced": "Шаг 3: Дополнительно",
            "Select test type": "Выберите вид теста",
            "Standard term according to price list": "Стандартный срок по прайс-листу",
            "Sample description": "Описание образца",
            "Soft tissue (parts of organs/muscles/skin)": "Мягкие ткани (части органов/мышцы/кожа)",
            "Stains on clothing or fabric": "Пятна на одежде или ткани",
            "Sperm on fabric / condom": "Сперма на ткани / презерватив",
            "Scanned copies of documents": "Скан-копии документов",
            Send: "Отправить",
            "Supreme administrator": "Руководитель департамента", //да, теперь так должно называться
            "Short name is required.": "Краткое наименование обязательно для заполнения.",
            "Select a role": "Выберите роль",
            "Show categories in trash can": "Показывать категории в корзине",
            "Select a category": "Выберите категорию",
            Search: "Поиск",
            "Search results": "Результаты поиска",
            "Send with corrections": "Отправить с исправлениями",
            "Search articles": "Поиск статей",
            Subject: "Тема",
            "Search by text": "Поиск по тексту",
            "Search by subject": "Поиск по теме",
            "Sorting by subject": "Сортировка по теме",
            "Search by title": "Поиск по названию",
            "Search by TIN or by title": "Поиск по ИНН или по названию",
            "Serial number": "Порядковый номер",
            "Short description": "Краткое описание",
            "Show processed appeals too": "Показывать также обработанные заявки",
            "Select date": "Выберите дату",
            "Select time of the day": "Выберите время дня",
            "Sample types are loading": "Виды образцов загружаются",
            "Select a preview for this test": "Выберите превью для этого теста",
            "Study periods are loading": "Сроки исследования загружаются",
            "Select the partner type": "Выберите тип партнера",
            "Something went wrong. Error code:": "Что-то пошло не так. Код ошибки:",
            "Select the partner": "Выберите партнера",
            "Search by creation date": "Поиск по дате создания",
            "Search by last message date": "Поиск по дате последнего сообщения",
            "Search by order number": "Поиск по номеру заказа",
            "Search by participant's name": "Поиск по имени участника",
            "Search by a number in Bitrix": "Поиск по номеру в Битриксе",
            "Search by a number of the order in Bitrix": "Поиск по номеру заказа в Битриксе",
            "Select a partner": "Выберите партнера",
            "Search by order id": "Поиск по номеру заказа",
            "Select a delivery branch": "Выберите филиал доставки",
            "Select files to order paper copies": "Выберите файлы для заказа бумажных копий",
            "Statuses are loading": "Статусы загружаются",
            "Select files": "Выберите файлы",
            "Sort by ID": "Сортировка по ID",
            "Sorting by creation date": "Сортировка по дате создания",
            "Search by closing date": "Поиск по дате закрытия",
            "Sorting by closing date": "Сортировка по дате закрытия",
            "Sorting by working time": "Сортировка по времени работы",
            "Standards for ticket responses": "Нормативы реакций на тикеты",
            Standard: "Норматив",
            "Services according to the price list": "Услуги по прайс-листу",
            "Search by invoice date": "Поиск по дате счета",
            "Server status": "Статус сервера",
            "Sorting by invoice date": "Сортировка по дате выставления счета",
            Sorting: "Сортировка",
            Select: "Выберите",
            "Support staff": "Сотрудник поддержки",
            Saturday: "Суббота",
            Sunday: "Воскресенье",
            "Start over": "Начать заново",
            "Suggest slots for the end customer": "Предложите слоты для конечного заказчика",
            "Send the slots to the manager": "Отправить слоты менеджеру",
            Statistics: "Статистика",
            "Statistics of recordings to partners": "Статистика записей к партнерам",
            "Studied the article": "Изучил статью",
            Stationary: "Стационарный",
            "Select a country": "Выберите страну",
            "Select a country first": "Сначала выберите страну",
            "Select a city": "Выберите город",
            Sample: "Образец",
            "Sample name": "Название образца",
            "Sample processing order": "Укажите очередность взятия образца в работу",
            "Sample processing priority": "Очередность",
            "Samples are loading": "Образцы загружаются",
            "Samples info": "Информация об образцах",
            "Save participant data": "Сохранить данные по участнику",
            "Select legal status": "Выберите юридический статус",
            "Select an attribute": "Выберите признак",
            "Select research period": "Выберите период исследования",
            "Sample types": "Виды образцов",
            SKU: "Артикул",
            "Samples that included into the category": "Образцы, которые входят в категорию",
            "Study period is not filled": "Срок исследования не заполнен",
            "Select a template": "Выберите шаблон",
            "Sort direction": "Направление сортировки",
            "Sort by title": "Сортировка по названию",
            "Sort by alias": "Сортировка по псевдониму",
            "Sort by active": "Сортировка по активности",
            "Sort by description": "Сортировка по описанию",
            "Sort by country": "Сортировка по стране",
            "Select partners": "Выберите партнеров",
            "Sort by TIN": "Сортировка по ИНН",
            Schema: "Схема",
            "Sort by status": "Сортировка по статуса",
            "Sort by partner": "Сортировка по партнеру",
            "Sort by order": "Сортировка по заказу",
            "Sort by question creation date": "Сортировка по дате создания вопроса",
            "Sort by question": "Сортировка по вопросу",
            "Sort by Question ID": "Сортировка по id вопроса",
            "Selected rule no longer exists or was deleted": "Выбранное правило больше не существует или было удалено",
            "Single answer": "Один ответ",
            "Save rules":
                "{n, plural, =0 {Сохранить правило} one {Сохранить правило} few {Сохранить правила} many {Сохранить правила} other {Сохранить правила}}",
            "Select a prepared list": "Выберите готовый список",
            "Select file type": "Выберите тип файла",
            "Select all": "Выбрать все",
            "Show table": "Показать таблицу",
            "Status change date": "Дата изменения статуса",
            "Show password": "Показать пароль",
            "signed in as":
                "Вы залогинены как {name}.\nВы уверены, что хотите выйти из аккаунта, чтобы зайти от лица другого пользователя?\nРекомендуем открыть вкладку в режиме инкогнито",
            "Sign in as another user": "Вход под другим пользователем",
            Settings: "Настройки",
            Sections: "Разделы",
            Section: "Раздел",
            Submenu: "Подменю",
            "Search by TIN": "Поиск по ИНН",
            Selected: "Выбрано",
            "Selected orders": "Выбранные заказы",
            "Submitted by the laboratory": "Передан лабораторией",
            "Submitted documents": "Предоставляемые документы",
            "Show changes history": "Посмотреть историю изменений",
            "Stages in B24": "Стадии Б24",
            "Sent by own courier": "Отправил своим курьером",
            "Samples not yet handed over": "Ещё не передал образцы",
            "Search by legal address": "Поиск по юр. адресу",
            "Search by manager": "Поиск по менеджеру",
            Start: "Начало",
            Show: "Показать",
            "Select subcategory": "Выберите подкатегорию",
            "Select kinship scheme": "Выберите схему родства",
            "Selected kinship scheme": "Выбранная схема родства",
            "Select category": "Выберите категорию",
            "Save the container record first to be able to add nested items.":
                "Сначала сохраните контейнер, чтобы иметь возможность добавлять вложенные элементы.",
            "Sync list": "Список синхронизации",
            "Select city": "Выберите город",
            "Super status": "Надстатус",
            "Supplement the current appeal": "Дополнить текущее обращение",
            "Statistics calculation rules": "Правило расчета статистики",
            "Sending original reports": "Отправка оригиналов заключения",
            "Super statuses, statuses, tags and buttons of appeals": "Надстатусы, статусы, теги, кнопки обращений",
            "Statuses and super statuses": "Статусы и надстатусы",
            "Statuses and super statuses table": "Таблица статусов и надстатусов",
            "Statuses and super statuses description": "Описание статусов и надстатусов",
            "Select additional service": "Выберите дополнительную услугу",
            "Select the additional service you want to order for order": "Выберите дополнительную услугу для заказа",
            "Select a service": "Выберите услугу",
            "Should the service be paid?": "Услуга должна быть платной?",
            "Service description": "Описание услуги",
            "Service movement": "Движение по услуге",
            "Smart-processes (SP) in B24": "Смарт-процессы (СП) в Б24",
            "Select First test type": "Выберите вид First test",
            Samples: "Образцы",
            "Samples in work": "Образцы берутся в работу",
            "Samples not in work": "Образцы НЕ берутся в работу",
            "Search by name or TIN": "Поиск по имени или ИНН",
            "Samples not selected": "Образцы не выбраны",
            "Sample is not included in the cost": "Образец не включен в цену",
            "Search all topics": "Поиск по всем темам",
            "Select a topic": "Выберите тему",
            subtopics: "подтем",
            "Show additional columns": "Показать дополнительные колонки",
            "Service transfers": "Переводов служб",

            //T
            "Templates are loading": "Шаблоны загружаются",
            Tue: "Вт",
            Thu: "Чт",
            "Type of test": "Вид теста",
            "Test participants": "Участники теста",
            "There are no orders.": "Нет ни одного заказа.",
            Test: "Тест",
            "This action cannot be undone": "Это действие нельзя будет отменить",
            "The trash can has been emptied": "Корзина очищена",
            "The category was successfully saved": "Категория успешно сохранена",
            "The category has been successfully updated": "Категория успешно обновлена",
            "There are no articles in the selected category": "Нет статей в выбранной категории",
            "There are no available categories": "Нет доступных категорий",
            'The preview is updated as soon as you select a new picture, i.e. the preview will be updated even if you don\'t click "Save".':
                'Превью обновляется как только вы выберете новую картинку, т.е. превью будет обновлено даже если вы не нажмете "Сохранить".',
            "There is not a single physical address, you must add at least one.":
                "Нет ни одного физического адреса, надо добавить хотя бы один.",
            "The partner has been successfully registered. Soon, the partner will receive a letter, on email address, chosen for login with the credentials for enter.":
                "Партнер успешно зарегистрирован. Скоро партнер получит письмо, на электронный адрес, выбранный для входа, с логином и паролем для входа.",
            "Track number of sent samples": "Трек-номер отправленных образцов",
            "Track number of sending the original report": "Трек-номер отправки оригинала заключения",
            "Translation of the conclusion into a foreign language": "Перевод заключения на иностранный язык",
            "Test other": "Тест другое",
            "There are no files.": "Файлы отсутствуют.",
            "The essence of the document": "Суть документа",
            "The essence of the document is not selected": "Суть документа не выбрана",
            "The user was successfully saved.": "Пользователь успешно сохранен.",
            "The user has been successfully updated.": "Пользователь успешно обновлен.",
            "The user was successfully deleted.": "Пользователь успешно удален.",
            "Transfer to another partner": "Перенести к другому партнеру",
            To: "До",
            "The partner has been successfully updated.": "Партнер успешно обновлен.",
            "Treason test": "Тест на измену",
            Toothbrush: "Зубная щетка",
            Toothpicks: "Зубочистки",
            Teeth: "Зубы",
            "total size up to": "общим размером до",
            "The application has already been processed.": "Заявка уже обработана.",
            "The decision was successfully made.": "Решение успешно принято.",
            "The order for DNA testing has been successfully created.":
                "Заказ на выполнение ДНК-тестирования успешно создан.",
            "The password must not be shorter than 6 characters.": "Пароль не должен быть короче 6 символов.",
            "The password is required.": "Пароль обязателен для заполнения.",
            "The files were successfully uploaded": "Файлы были успешно загружены",
            "TIN must be a number.": "ИНН должен быть числом.",
            "The TIN consists of 10 digits.": "ИНН состоит из 10 цифр.",
            "TIN is required to be filled out.": "ИНН обязателен для заполнения.",
            "The registration reason code must be a number.": "КПП должен быть числом.",
            "The registration reason code consists of 9 digits.": "КПП состоит из 9 цифр.",
            "The registration reason code is required to be filled out.": "КПП обязателен для заполнения.",
            "The checking account must be a number.": "Расчетный счет должен быть числом.",
            "The checking account consists of 20 digits.": "Расчетный счет состоит из 20 цифр.",
            "The checking account is required to be filled out.": "Расчетный счет обязателен для заполнения.",
            "The correspondent account must be a number.": "Корреспондентский счет должен быть числом.",
            "The correspondent account consists of 20 digits.": "Корреспондентский счет состоит из 20 цифр.",
            "The correspondent account starts with 301.": "Корреспондентский счет начинается с 301.",
            "The correspondent account is required to be filled out.":
                "Корреспондентский счет обязателен для заполнения.",
            "The name of the bank is required to be filled out.": "Наименование банка обязательно для заполнения.",
            "The sign is required to be filled out.": "Признак обязателен для заполнения.",
            "The test type is required.": "Вид теста обязателен для заполнения.",
            "The previous order number is required.": "Номер предыдущего заказа обязателен для заполнения.",
            "The study period is required to be filled out.": "Срок исследования обязателен для заполнения.",
            "The description of the sample is required to be filled out.":
                "Описание образца обязательно для заполнения.",
            "The sample type is required.": "Вид образца обязателен для заполнения.",
            "The test description is required.": "Описание теста обязательно для заполнения.",
            'The field "Who collected the samples" is required.':
                'Поле "Кто собрал образцы" обязательно для заполнения.',
            "The article was successfully saved.": "Статья успешно сохранена.",
            "The phone cannot be empty.": "Телефон не может быть пустым.",
            "The physical address cannot be empty.": "Физический адрес не может быть пустым.",
            "There are no nested categories.": "Нет вложенных категорий.",
            "The password must not be shorter than some characters.": "Пароль не должен быть короче {count} символов.",
            "There are unreliable data": "Есть недостоверные данные",
            "Type a new value": "Впишите новое значение",
            "There are no contacts": "Нет контактов",
            "The request performed successfully.": "Запрос успешно выполнен.",
            Text: "Текст",
            "There are no appeals": "Нет обращений",
            Title: "Название",
            "The new test has been successfully created": "Новый тест был успешно создан",
            "The test has been successfully updated": "Тест был успешно обновлен",
            "The test in trash": "Тест в корзине",
            "Tests in trash": "Тесты в корзине",
            "Type a complete email": "Напишите email полностью",
            "The courier was successfully called. Expect.": "Курьер успешно вызван. Ожидайте.",
            "The opened order": "Открытый заказ",
            "The test data isn't loaded": "Данные по тесту не загрузились",
            "This appeal is closed.": "Это обращение закрыто.",
            "The order is in trash": "Заказ находится в корзине",
            "The order is loading": "Заказ загружается",
            "The barcodes are fetching": "Штрихкоды загружаются",
            "The address where the courier should arrive": "Адрес куда должен приехать курьер",
            "Type of partner": "Тип партнера",
            "This field is required": "Это поле обязательно для заполнения",
            "This field must be a number": "Это поле должно быть числом",
            "Time zone": "Часовой пояс",
            "The participant editing/adding form is not empty. Please add/edit the participant or clear the form.":
                "Форма редактирования/добавления участников не пуста. Пожалуйста добавьте/отредактируйте участника или очистите форму.",
            Type: "Тип",
            "Type of the provided document": "Тип предоставленного документа",
            "The value is incorrect": "Значение не верно",
            "This document is not available for delivery": "Данный документ не доступен для доставки",
            "Track number": "Трек-номер",
            "This address already has such a phone number": "У этого адреса уже есть такой телефон",
            "To call the courier again, please wait for the current request to be closed":
                "Для повторного вызова курьера дождитесь закрытия текущей заявки",
            "The tracking number will be available for 24 hours on the order page":
                "Трек-номер для отслеживания будет доступен в течение 24 часов на странице заказа",
            "The status of the courier call request": "Состояние заявки на вызов курьера",
            "Topics are loading": "Темы загружаются",
            Topic: "Тема",
            "The message must be at least 10 characters long and no longer than 1000 characters":
                "Сообщение не должно быть короче 10 символов и не должно быть длиннее 1000 символов",
            "Time has passed since the creation": "Прошло времени c момента создания",
            "The server returned an empty result": "Сервер вернул пустой результат",
            "The message must be no longer than 1000 characters": "Сообщение не должно быть длиннее 1000 символов",
            "This setting only works in this browser": "Эта настройка работает только в этом браузере",
            "Turn on/off notifications": "Включить/выключить уведомления",
            "The current value can only be changed in the settings of the current browser":
                "Текущее значение можно изменить только в настройках текущего браузера",
            "The status of the ticket has changed": "У тикета изменился статус",
            "Ticket types": "Типы тикетов",
            "Ticket urgency": "Срочность тикетов",
            "Ticket statuses": "Статусы тикетов",
            "Ticket type": "Тип тикета",
            "This section will soon become unavailable. Please use:":
                "Этот раздел скоро станет недоступен. Пожалуйста используйте:",
            "The date by which the slide should be shown": "Дата, до которой должен показываться слайд",
            "The time in seconds that the slide should be visible": "Время в секундах, которое должен быть виден слайд",
            "The server did not return any slides": "Сервер не вернул ни одного слайда",
            "The slide data is loading": "Данные слайда загружаются",
            "The server did not return any roles": "Сервер не вернул ни одной роли",
            "Total orders": "Всего заказов",
            "The order is overdue": "Заказ просрочен",
            "The order is stopped": "Заказ остановлен",
            "The partner's request is taking too long to resolve": "Запрос партнера решается слишком долго",
            Tuesday: "Вторник",
            Thursday: "Четверг",
            "The quantity cannot be zero": "Количество не может быть нулевым",
            "This field consists of some digits": "Это поле состоит из {digits} цифр",
            "The partner has been successfully verified": "Партнер успешно верифицирован",
            TIN: "ИНН",
            "Total number of transactions": "Общее количество сделок",
            "Total sum": "Общая сумма",
            "The status is created automatically when the ticket is created, no one can set it manually":
                "Статус создается автоматически, при создании тикета, никто не может установить его принудительно",
            "The meeting did not take place": "Встреча не состоялась",
            "Visit took place, the samples were not received": "Визит состоялся, образцы не получены",
            "This article should be studied by the partner's employees":
                "Эта статья должна быть изучена сотрудниками партнера",
            Trained: "Обучен",
            "Title of the article": "Название статьи",
            "There are unread messages": "Есть непрочитанные сообщения",
            "There is not a single company phone, at least one needs to be added":
                "Нет ни одного телефона компании, надо добавить хотя бы один",
            "Title in English": "Название на английском",
            "The partner has confirmed their information": "Партнер подтвердил свои данные",
            "The partner has not confirmed its information or the partner has rejected its information":
                "Партнер не подтвердил свои данные или партнер отклонил свои данные",
            "Total photos": "Всего фотографий",
            "The survey has been conducted. I confirm the data in the order.":
                "Опрос проведен, данные в заказе подтверждаю.",
            "The client must be interviewed to determine their needs and the order should be formed based on the information obtained from the client, not on the preliminary information provided by the laboratory.":
                "Требуется опросить клиента, определить потребности клиента, сформировать заказ исходя из информации полученной от клиента, а не из предварительно переданной от лаборатории информации.",
            "The client survey has been completed": "Опрос клиента проведен",
            "The client must be informed about the rules for conducting research using non-standard biological DNA samples, notified of the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and agrees to conduct the research.":
                "Клиент проинформирован о правилах проведения исследования с использованием нестандартных биологических образцов ДНК, уведомлен о возможности не выделения ДНК из предоставленных нестандартных образцов и финансовых и прочих условиях, связанных со спецификой выделения ДНК из нестандартных образцов, об условиях возврата образцов и согласен с проведением исследования.",
            "The Call a courier and Add track number buttons will become available after informing the client about non-standard samples":
                "Кнопки «Вызвать курьера» и «Добавить трек-номер» станут доступны после информирования клиента о нестандартных образцах",
            "The Call a courier and Add track number buttons will become available after conducting the survey and informing the client about non-standard samples":
                "Кнопки «Вызвать курьера» и «Добавить трек-номер» станут доступны после проведения опроса и информирования клиента о нестандартных образцах",
            "The partner confirmed that they informed the client about the rules for conducting research using non-standard biological DNA samples. The partner notified the client about the possibility of DNA not being extracted from the provided non-standard samples and financial and other conditions related to the specifics of DNA extraction from non-standard samples, about the conditions for returning samples and received consent to conduct the research. The document signed by the client remains with the partner.":
                "Партнер подтвердил, что проинформировал клиента о правилах проведения исследования с использованием нестандартных биологических образцов ДНК. Партнер уведомил клиента о возможности не выделения ДНК из предоставленных нестандартных образцов и финансовых и прочих условиях, связанных со спецификой выделения ДНК из нестандартных образцов, об условиях возврата образцов и получил согласие на проведение исследования. Документ, подписанный клиентом, остается у партнера.",
            "The partner interviewed the client, identified the client's needs, and created the order based on information obtained from the client rather than on preliminary information provided by the laboratory.":
                "Партнер опросил клиента, определил потребности клиента, сформировал заказ исходя из информации полученной от клиента, а не из предварительно переданной от лаборатории информации",
            Testing: "Тестирование",
            "The test participant form is not empty. Please return to step 2 and complete the form or clear the form.":
                "Форма заполнения участника теста не пуста. Вернитесь на 2 шаг и заполните форму до конца или очистите форму.",
            "To create an order, fill in the required fields:": "Чтобы создать заказ, заполните обязательные поля:",
            "Template message": "Шаблонное сообщение",
            "Time between the last messages": "Время между последними сообщениями",
            "Test is not filled": "Тест не заполнен",
            "To schedule a courier you must first confirm the order details":
                "Чтобы заказать курьера, сначала подтвердите информацию в заказе",
            "To select a sample, complete step 1": "Чтобы выбрать образец заполните 1 шаг",
            "Ticket id": "id обращения",
            "The title must be less than 255 characters": "Название должно быть меньше 255 символов",
            "The alias must be less than 255 characters": "Псевдоним должен быть меньше 255 символов",
            "Time unit": "Единицы времени",
            "Title must be less than 255 characters": "Название должно содержать не более 255 символов",
            "TIN must be less than 20 characters": "ИНН должен содержать не более 20 символов",
            "Template questions": "Шаблонные вопросы",
            "Type is required": "Тип обязателен для заполнения",
            "Temporary login": "Временный логин",
            "Temporary password": "Временный пароль",
            "The client may change test parameters at any time. Make sure the price is calculated correctly according to the price list and verify the pre-order parameters":
                "Клиент может изменить параметры теста в любой момент. Необходимо убедиться в корректности расчета цены по прайсу и проверить параметры предварительного заказа",
            "This menu item has sub-items": "У этого пункта меню есть вложенные пункты",
            "Types of samples": "Типы образцов",
            "To assign a single track number to all your selected orders, enter it here":
                "Чтобы присвоить всем выбранным Вами заказам один трек-номер впишите его сюда",
            "This field must be less than 255 characters": "Это поле должно быть меньше 255 символов",
            "Track number added successfully": "Трек номер успешно добавлен",
            "The Call a courier and Add track number buttons will become available after conducting the survey":
                "Кнопки «Вызвать курьера» и «Вписать трек номер» станут доступны после проведения опроса",
            ToFilter: "Фильтровать",
            "The list is empty": "Список пуст",
            "The mass mailing has been sent successfully": "Массовая рассылка успешно отправлена",
            "The field will be changed to value. The price may change.":
                'Поле "{field}" будет изменено на значение "{value}". Возможно будет изменена цена.',
            "The displayed price is preliminary and is based on the test parameters":
                "Сейчас отражена предварительная цена по параметрам теста, которые назвал клиент. Проверяйте соответствие в карточке заказа и параметры теста, которые клиент назовет Вам при сдаче образцов.",
            "Ticket templates": "Шаблоны тикетов",
            "The answer is incomplete, clarifications are required": "Ответ неполный, требуются уточнения",
            "There is no answer to the essence of the question": "Нет ответа на суть вопроса",
            "To save the order, complete the mandatory steps": "Чтобы сохранить заказ, заполните обязательные поля:",
            "The cache was successfully reset": "Кеш был успешно сброшен",
            "Type at least 3 characters": "Введите хотя бы 3 символа",
            "Type at least 10 characters": "Введите хотя бы 10 символов",
            "This field is filled in automatically": "Это поле заполняется автоматически",
            "Table fields list": "Перечень полей ЛК",
            Tags: "Теги",
            "To write a message, use the corresponding button:":
                "Чтобы написать сообщение воспользуйтесь соответствующей кнопкой:",
            "Total dialogue lifetime": "общее время существования диалога",
            "Tags table": "Таблица тегов",
            "Tags description": "Описание тегов",
            "This service is not available for the current order parameters":
                "Эта услуга недоступна для текущих параметров заказа",
            "Test type and order form fields relation": "Соотношение Вида теста и полей к заполнению",
            "Test parameters": "Параметры теста",
            "Test type": "Вид теста",
            "Test type and order form field relation": "Соотношение Вида теста и поля к заполнению",
            "Temporary partner transfer": "Временный перенос партнёров",
            "Transfer to other Manager": "Перенести другому менеджеру",
            "Transfer date to": "Дата переноса",
            "Transfer date back": "Дата переноса назад",
            Transfer: "Перенести",
            "TIN is required.": "ИНН обязателен для заполнения.",
            "Ticket topics": "Темы обращений",
            "There are no topics in this category": "В этой категории нет тем",
            "Topic path": "Путь темы",
            "Topics could not be loaded": "Не удалось загрузить темы",
            "Try another search": "Попробуйте другой запрос",
            "Topic changes": "Изменений темы",

            //U
            Users: "Пользователи",
            "User ID": "ID пользователя",
            "Urgent delivery of the report by courier": "Срочная отправка заключения курьером",
            Upload: "Загрузить",
            "Uploading documents": "Загрузка документов",
            "Upload files": "Загрузить файлы",
            "Uploaded files": "Загруженные файлы",
            "Uploaded documents": "Загруженные документы",
            Update: "Обновить",
            "Until the court's decision": "До решения суда",
            "Unauthorized user": "Неавторизованный пользователь",
            Updated: "Обновлено",
            "Unfortunately, an error occurred while loading partner types.":
                "К сожалению при загрузке типов партнеров произошла ошибка.",
            "Unfortunately, an error occurred while loading managers.":
                "К сожалению при загрузке менеджеров произошла ошибка.",
            "Unfortunately, an error occurred while loading roles for a contact.":
                "К сожалению при загрузке ролей для контакта произошла ошибка.",
            "Unfortunately, roles weren't loaded.": "К сожалению роли не были загружены.",
            Urgency: "Срочность",
            "Urgency is loading": "Срочность загружается",
            "User data": "Данные пользователя",
            "Unpaid orders": "Не оплаченных заказов",
            Unsubscibe: "Отписаться",
            "User is blocked": "Пользователь заблокирован",
            Use: "Использовать",
            "Upload photos of test participant.": "Загрузите фотографии участника тестирования.",
            "Upload files of an identity document.": "Загрузите файлы документа, удостоверяющего личность.",
            "Unable to verify the information in the order — not all fields are filled in":
                "Невозможно подтвердить информацию в заказе, не все поля заполнены",
            "Update data?": "Обновить данные?",
            "Unread messages": "Непрочитанные сообщения",
            UNread: "НЕпрочитано",
            "Upload the required documents before changing the order status":
                "Загрузите необходимые документы, прежде чем менять статус заказа",
            "Upload a signed consent document for the participant with a nonstandard sample.":
                "Загрузите подписанное согласие для участника с нестандартным образцом.",
            "Upload the files of the ready profile": "Загрузите файлы готового профиля",
            "Use the circle to choose a topic or click a category to browse":
                "Используйте круг для выбора темы или нажмите на категорию, чтобы просмотреть дочерние темы",

            //V
            "Valid extensions": "Допустимые расширения",
            "valid formats": "допустимые форматы",
            Value: "Значение",
            "View application": "Просмотр заявки",
            View: "Просмотр",
            "Verify the caller as a partner by phone number": "Верифицируйте звонящего как партнера по номеру телефона",
            Verify: "Верифицировать",
            "Visit took place": "Визит состоялся, образцы получены",
            "Visit took place successfully": "Визит состоялся успешно",
            "Value is required": "Значение обязательно для заполнения",
            "Values are required": "Значения обязательны для заполнения",
            "Value type": "Тип значения",
            "Value type is required": "Тип значения обязателен для заполнения",
            "Visit took place, determination received": "Визит состоялся, есть определение",

            //W
            Wed: "Ср",
            "Written consultation with a test specialist": "Письменная консультация специалиста по тесту",
            "Who collected the samples": "Кто произвел забор образцов",
            "What to do with existing orders from this partner?":
                "Что делать с существующими заказами данного партнера?",
            "Watch strap": "Ремешок от часов",
            "Write a message": "Напишите сообщение",
            "Who collected samples variants are loading": "Варианты кто собрал образцы загружаются",
            "When the courier will arrive, time from": "Когда приедет курьер, время от",
            "When the courier will arrive, time to": "Когда приедет курьер, время до",
            "Was read": "Было прочитано",
            "Working hours": "Рабочее время",
            "What status should be assigned to the existing tickets instead of the one being deleted?":
                "Какой статус присвоить уже существующим тикетам вместо удаляемого?",
            "What value should be assigned to the existing tickets instead of the one being deleted?":
                "Какое значение присвоить уже существующим тикетам вместо удаляемого?",
            "Working hours from": "Рабочее время от",
            "Working hours to": "Рабочее время до",
            "Working hours of employees": "Рабочее время сотрудников",
            Wednesday: "Среда",
            "Who created the appeal": "Кто создал обращение",
            "Write a message on another topic": "Написать сообщение по другому вопросу",
            "When creating an order with a nonstandard sample, you must upload a signed consent document.":
                "При создании заказа с нестандартным образцом необходимо загрузить подписанное согласие.",

            //X
            "X chromosome": "X-хромосома",

            //Y
            "You have successfully logged in. You can go to the section you need.":
                "Вы успешно вошли. Можете перейти в нужный вам раздел.",
            "You've successfully exited.": "Вы успешно вышли.",
            "Your manager": "Ваш менеджер",
            Yes: "Да",
            "You can download up to": "За раз можно загрузить до",
            "Your profile": "Ваш профиль",
            "Your account roles": "Роли вашего аккаунта",
            "You cannot add more participants.": "Больше участников добавить нельзя.",
            "Y chromosome": "Y-хромосома",
            "You can upload": "Вы можете загрузить",
            "You have uploaded the maximum number of files.": "Вы загрузили максимальное количество файлов.",
            "You have exceeded the maximum files upload size.": "Вы превысили максимальный размер загружаемых файлов.",
            "You do not have access to this section.": "У вас нет доступа в этот раздел.",
            "You are making too many requests.": "Вы делаете слишком много запросов.",
            "You cannot add more than {{count}} participants.": "Нельзя добавить больше {{count}} участников.",
            You: "Вы",
            "You need to choose the type of partner.": "Вам нужно выбрать тип партнера",
            "Your application has been accepted. It will appear in the order list within 5-10 minutes, and you will be sent an invoice for payment.":
                "Ваша заявка принята. В течение 5-10 минут она появится в списке заказов и Вам будет направлен счет на оплату.",
            "You have not made a decision yet": "Вы еще не приняли решение",
            "You have enabled push notifications on this device": "Вы разрешили Push-уведомления на этом устройстве",
            "You have disabled push notifications on this device": "Вы запретили Push-уведомления на этом устройстве",
            "You are going to delete the status": "Вы собираетесь удалить статус",
            "You cannot assign a child as a parent (cyclic dependency)":
                "Вы не можете назначить дочерний элемент в качестве родительского (циклическая зависимость)",
            "You do not have permission to perform this action": "У вас нет прав на совершение этого действия",
            "You can't select a date from the past": "Вы не можете выбрать дату из прошлого",
            "You cannot select a past date": "Нельзя выбрать прошедшую дату",
            "You have reached the 255 character limit": "Вы достигли лимита в 255 символов",
            "You have returned from the order page. The data in the table may have changed. Update the table?":
                "Вы вернулись со страницы заказа. Возможно, данные в таблице изменились. Обновить таблицу?",
            "Your courier track number": "Трек-номер вашего курьера",
            "You are logged in as": "Вы залогинены как",
            "Your answers": "Ваши ответы",
            "You cannot call a courier. You need to mark the result and/or upload documents for the orders.":
                "Вы не можете вызвать курьера. Необходимо отметить результат и/или загрузить документы по заказам",

            //Z

            "1 day(24 hours)": "1 день (24 часа)",
            "2 days(48 hours)": "2 дня (48 часов)",
        },
    },
};

const defaultLang = "ru";
const storageLangKey = "inlabB2BUserLang";

let langFromStorage;
try {
    langFromStorage = localStorage.getItem(storageLangKey);
} catch (e: unknown) {
    langFromStorage = defaultLang;
}

if (langFromStorage === null) {
    localStorage.setItem(storageLangKey, defaultLang);
    initI18N({ lang: defaultLang });
} else {
    initI18N({ lang: langFromStorage });
}

export function getLangFromStorage() {
    const langFromStorage = localStorage.getItem(storageLangKey);
    if (langFromStorage === null) {
        return defaultLang;
    } else {
        return langFromStorage;
    }
}

function initI18N({ lang }: { lang: string }) {
    i18n.use(ICU)
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources,
            lng: lang, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
            // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
            // if you're using a language detector, do not define the lng option

            interpolation: {
                escapeValue: false, // react already safes from xss
                prefix: "{{",
                suffix: "}}",
            },
        });
}

export function setUserLangToStorage({ lang }: { lang: string }) {
    localStorage.setItem(storageLangKey, lang);
}

export default i18n;
